import type { Idioma } from './IdiomaProvider';

type Dicionario = Record<string, string>;

export const FRASES_COMUNS: Record<Idioma, Dicionario> = {
  pt: {
    "Trocar de empresa": "Trocar de empresa",
    Calendário: "Calendário",
    "Planeje e acompanhe as tarefas de suporte por data.": "Planeje e acompanhe as tarefas de suporte por data.",
    "Nova tarefa": "Nova tarefa",
    Tarefas: "Tarefas",
    Tickets: "Tickets",
    "Em andamento": "Em andamento",
    Aguardando: "Aguardando",
    Concluído: "Concluído",
    "Novo chamado": "Novo chamado",
    "Tarefa do calendário": "Tarefa do calendário",
    "Pedido do cliente": "Pedido do cliente",
    "Chamado avulso": "Chamado avulso",
    "Visualizar chamado": "Visualizar chamado",
    "Abrir menu da tarefa": "Abrir menu da tarefa",
    "Editar tarefa": "Editar tarefa",
    "Excluir tarefa": "Excluir tarefa",
    "Mover para": "Mover para",
    "Voltar para": "Voltar para",
    "Suporte — Visão Geral": "Suporte — Visão Geral",
    "Suporte — Dashboard": "Suporte — Dashboard",
    "Login de suporte": "Login de suporte",
    Todos: "Todos",
    "Visualizar tarefa": "Visualizar tarefa",
    "Dados da tarefa": "Dados da tarefa",
    "Tarefa sem título": "Tarefa sem título",
    "Sem descrição.": "Sem descrição.",
    "Criado por": "Criado por",
    Início: "Início",
    Fim: "Fim",
    Tags: "Tags",
    "Tempo médio de atendimento": "Tempo médio de atendimento",
    "Resposta média do chamado": "Resposta média do chamado",
    "Chamados sem início": "Chamados sem início",
    "Mês de maior fluxo": "Mês de maior fluxo",
    "Equipe de suporte": "Equipe de suporte",
    "Cards por usuário com volume, tempos e itens ativos.": "Cards por usuário com volume, tempos e itens ativos.",
    Ativos: "Ativos",
    Resposta: "Resposta",
    Atendimento: "Atendimento",
    "Sem dados suficientes.": "Sem dados suficientes.",
    "Fluxo mensal de atendimento": "Fluxo mensal de atendimento",
    "Distribuição de chamados abertos nos últimos 12 meses.": "Distribuição de chamados abertos nos últimos 12 meses.",
    "SLA de resposta": "SLA de resposta",
    "Média frente à meta de 8h.": "Média frente à meta de 8h.",
    "Tickets Abertos": "Tickets Abertos",
    "Resolvidos Hoje": "Resolvidos Hoje",
    "SLA Médio": "SLA Médio",
    "Tempo Médio de Resposta": "Tempo Médio de Resposta",
    "Satisfação do Cliente": "Satisfação do Cliente",
    "Pesquisa de Satisfação": "Pesquisa de Satisfação",
    "Detalhes da venda": "Detalhes da venda",
    Onboarding: "Onboarding",
    "Defina o idioma da plataforma": "Defina o idioma da plataforma",
    "vs semana anterior": "vs semana anterior",
    "vs ontem": "vs ontem",
    "Em Andamento": "Em Andamento",
    "Crítica": "Crítica",
    "Evolução de Tickets": "Evolução de Tickets",
    "Últimos 7 dias": "Últimos 7 dias",
    "Últimos 14 dias": "Últimos 14 dias",
    "Últimos 30 dias": "Últimos 30 dias",
    "Distribuição por Prioridade": "Distribuição por Prioridade",
    "tickets": "tickets",
    "Status do Atendimento": "Status do Atendimento",
    "Novos": "Novos",
    "Aguardando Cliente": "Aguardando Cliente",
    "Em Atendimento": "Em Atendimento",
    "Escalados": "Escalados",
    "Finalizados": "Finalizados",
    "Tickets Recentes": "Tickets Recentes",
    "Ver todos": "Ver todos",
    "Assunto": "Assunto",
    "Canal": "Canal",
    "Ver ranking": "Ver ranking",
    "Última Atualização": "Última Atualização",
    "tickets resolvidos": "tickets resolvidos",
    "Resposta média": "Resposta média",
    "Radar do suporte": "Radar do suporte",
    "Comparativo normalizado dos principais responsáveis.": "Comparativo normalizado dos principais responsáveis.",
    "Atendimentos por suporte": "Atendimentos por suporte",
    "Atendimentos": "Atendimentos",
    "Total de atendimentos por mês": "Total de atendimentos por mês",
    "Atendimentos de janeiro a dezembro.": "Atendimentos de janeiro a dezembro.",
    "Chamados concluídos, ativos e tarefas por responsável.": "Chamados concluídos, ativos e tarefas por responsável.",
    "Resposta média por suporte": "Resposta média por suporte",
    "Horas entre chegada do chamado e início do atendimento.": "Horas entre chegada do chamado e início do atendimento.",
    "Dashboard de Suporte": "Dashboard de Suporte",
    "Panorama do Kanban, dos chamados e das tarefas do calendário.": "Panorama do Kanban, dos chamados e das tarefas do calendário.",
    "Erro ao carregar a visão geral.": "Erro ao carregar a visão geral.",
    "Chamados por status": "Chamados por status",
    "Por prioridade": "Por prioridade",
    "Por categoria": "Por categoria",
    "Itens do Kanban por etapa": "Itens do Kanban por etapa",
    "Chamados e tarefas no fluxo atual.": "Chamados e tarefas no fluxo atual.",
    "Carga ativa por responsável": "Carga ativa por responsável",
    "Itens ainda não concluídos.": "Itens ainda não concluídos.",
    "Tarefas do calendário por prioridade": "Tarefas do calendário por prioridade",
    "Evolução dos chamados": "Evolução dos chamados",
    "Aberturas e conclusões nos últimos 6 meses.": "Aberturas e conclusões nos últimos 6 meses.",
    "Agenda dos próximos 7 dias": "Agenda dos próximos 7 dias",
    "Tarefas não concluídas por data programada.": "Tarefas não concluídas por data programada.",
    "Movimentações do Kanban": "Movimentações do Kanban",
    "Atividade registrada nos últimos 14 dias.": "Atividade registrada nos últimos 14 dias.",
    "Atividade registrada nos últimos 15 dias.": "Atividade registrada nos últimos 15 dias.",
    "Sem responsável": "Sem responsável",
    Concluídos: "Concluídos",
    "Registrar movimentação do Kanban": "Registrar movimentação do Kanban",
    "Confirmar movimentação": "Confirmar movimentação",
    "Etapa de destino": "Etapa de destino",
    "Informe o que foi feito ou o motivo da movimentação...": "Informe o que foi feito ou o motivo da movimentação...",
    "Informe o que foi feito ou o motivo da movimentação.": "Informe o que foi feito ou o motivo da movimentação.",
    "Não foi possível salvar um dos anexos da movimentação.": "Não foi possível salvar um dos anexos da movimentação.",
    "Movimentação inválida para a etapa atual do Kanban.": "Movimentação inválida para a etapa atual do Kanban.",
    "Adicionar tarefa": "Adicionar tarefa",
    "Carregando itens...": "Carregando itens...",
    "Nenhum item nesta etapa.": "Nenhum item nesta etapa.",
    "Linha do tempo": "Linha do tempo",
    "Histórico do atendimento": "Histórico do atendimento",
    "Chamado aberto": "Chamado aberto",
    "Tarefa criada": "Tarefa criada",
    "Nenhum histórico disponível.": "Nenhum histórico disponível.",
    "Etapa não utilizada.": "Etapa não utilizada.",
    "Mostrar todos os históricos": "Mostrar todos os históricos",
    "Mostrar somente o concluído selecionado": "Mostrar somente o concluído selecionado",
    "Clique em um item concluído para ver a linha do tempo.": "Clique em um item concluído para ver a linha do tempo.",
    "Editar chamado": "Editar chamado", "Excluir chamado": "Excluir chamado",
    "Registrar avanço do Kanban": "Registrar avanço do Kanban",
    "Descreva o que foi feito ou o motivo da mudança de etapa.": "Descreva o que foi feito ou o motivo da mudança de etapa.",
    "Confirmar avanço": "Confirmar avanço", Item: "Item", "Próxima etapa": "Próxima etapa", "Registro da etapa": "Registro da etapa",
    "Informe o que foi feito ou o motivo do avanço...": "Informe o que foi feito ou o motivo do avanço...",
    "Informe o que foi feito ou o motivo do avanço.": "Informe o que foi feito ou o motivo do avanço.",
    "Não foi possível salvar um dos anexos do avanço.": "Não foi possível salvar um dos anexos do avanço.",
    "Movimentação inválida. Avance o item seguindo a sequência do Kanban.": "Movimentação inválida. Avance o item seguindo a sequência do Kanban.",
    "Chamados não podem ser excluídos pelo Kanban.": "Chamados não podem ser excluídos pelo Kanban.", "anexo(s)": "anexo(s)",
    "Movimente o chamado pelo Kanban e registre o que foi feito ou o motivo do avanço.": "Movimente o chamado pelo Kanban e registre o que foi feito ou o motivo do avanço.",
    "Item movido com sucesso.": "Item movido com sucesso.",
    "Não foi possível mover o item.": "Não foi possível mover o item.",
    "Tarefa excluída com sucesso.": "Tarefa excluída com sucesso.",
    "Chamado excluído com sucesso.": "Chamado excluído com sucesso.",
    "Não foi possível excluir o chamado.": "Não foi possível excluir o chamado.",
    "Excluir a tarefa": "Excluir a tarefa",
    "Chamado sem título": "Chamado sem título",
    "Quadro visual de tarefas, pedidos e chamados com prioridade, data de início e pessoa responsável.": "Quadro visual de tarefas, pedidos e chamados com prioridade, data de início e pessoa responsável.",
    "Item ou etapa do Kanban inválida.": "Item ou etapa do Kanban inválida.",
    "Você não tem permissão para movimentar este chamado.": "Você não tem permissão para movimentar este chamado.",
    "Você não tem permissão para movimentar esta tarefa.": "Você não tem permissão para movimentar esta tarefa.",
    "Consumo de E-mails por Organização": "Consumo de E-mails por Organização",
    "Acompanhe a cota mensal usada e disponível em cada organização.": "Acompanhe a cota mensal usada e disponível em cada organização.",
    Período: "Período",
    "Total geral": "Total geral",
    Limite: "Limite",
    "Total usado": "Total usado",
    "Total livre": "Total livre",
    "Última alteração": "Última alteração",
    "Ativar API Resend para envio de e-mails": "Ativar API Resend para envio de e-mails",
    "Quando desativada, nenhum e-mail automático será enviado.": "Quando desativada, nenhum e-mail automático será enviado.",
    Ação: "Ação",
    "Limite mensal de e-mails": "Limite mensal de e-mails",
    "Salvar limite mensal": "Salvar limite mensal",
    "Nenhuma organização disponível para acompanhar.": "Nenhuma organização disponível para acompanhar.",
    "API Resend ativada com sucesso.": "API Resend ativada com sucesso.",
    "API Resend desativada com sucesso.": "API Resend desativada com sucesso.",
    "Erro ao atualizar a API Resend.": "Erro ao atualizar a API Resend.",
    "Informe um limite mensal válido.": "Informe um limite mensal válido.",
    "Erro ao salvar o limite de e-mails.": "Erro ao salvar o limite de e-mails.",
    "Limite de e-mails atualizado com sucesso.": "Limite de e-mails atualizado com sucesso.",
    Enviados: "Enviados",
    Reclamados: "Reclamados",
    Atrasados: "Atrasados",
    "Entregabilidade de E-mails": "Entregabilidade de E-mails",
    "Envios e eventos do Resend por dia, nos últimos 30 dias (conta inteira).": "Envios e eventos do Resend por dia, nos últimos 30 dias (conta inteira).",
    "Limite Diário de Envio": "Limite Diário de Envio",
    "Limite diário": "Limite diário",
    "Enviados hoje": "Enviados hoje",
    "Restante hoje": "Restante hoje",
    "Limite diário de e-mails": "Limite diário de e-mails",
    "Salvar limite diário": "Salvar limite diário",
    "Limite da conta Resend, compartilhado por todas as organizações. Ao ser atingido, novos envios ficam em espera até o dia seguinte para evitar erros do Resend.": "Limite da conta Resend, compartilhado por todas as organizações. Ao ser atingido, novos envios ficam em espera até o dia seguinte para evitar erros do Resend.",
    "Informe um limite diário válido.": "Informe um limite diário válido.",
    "Erro ao salvar o limite diário de e-mails.": "Erro ao salvar o limite diário de e-mails.",
    "Limite diário de e-mails atualizado com sucesso.": "Limite diário de e-mails atualizado com sucesso.",
    "Configure o segredo do webhook Resend acima para que os eventos de entrega, abertura e clique comecem a aparecer aqui.": "Configure o segredo do webhook Resend acima para que os eventos de entrega, abertura e clique comecem a aparecer aqui.",
    "Erro ao atualizar o envio de e-mails da organização.": "Erro ao atualizar o envio de e-mails da organização.",
    "Envio de e-mails ativado para a organização.": "Envio de e-mails ativado para a organização.",
    "Envio de e-mails desativado para a organização.": "Envio de e-mails desativado para a organização.",
    "8+ Caracteres": "8+ Caracteres",
    "Letra Maiúscula": "Letra Maiúscula",
    "Especial (!@#)": "Especial (!@#)",
    Número: "Número",
    "Não foi possível confirmar os dados gerais salvos no banco.": "Não foi possível confirmar os dados gerais salvos no banco.",
    "Erro ao salvar a chave.": "Erro ao salvar a chave.",
    "Aparência e funcionalidades salvas com sucesso.": "Aparência e funcionalidades salvas com sucesso.",
    "Erro ao salvar aparência e funcionalidades.": "Erro ao salvar aparência e funcionalidades.",
    "Cor do plano de fundo da sidebar": "Cor do plano de fundo da sidebar",
    "Opacidade do plano de fundo da sidebar": "Opacidade do plano de fundo da sidebar",
    "Gradiente do plano de fundo": "Gradiente do plano de fundo",
    "Gradiente botões": "Gradiente botões",
    "Gradiente plano de fundo": "Gradiente plano de fundo",
    "Inverter gradiente": "Inverter gradiente",
    "Gradiente 1 - superior esquerdo": "Gradiente 1 - superior esquerdo",
    "Gradiente 2 - inferior direito": "Gradiente 2 - inferior direito",
    "Tamanho do gradiente 1": "Tamanho do gradiente 1",
    "Tamanho do gradiente 2": "Tamanho do gradiente 2",
    "Movimento horizontal do gradiente 1": "Movimento horizontal do gradiente 1",
    "Movimento vertical do gradiente 1": "Movimento vertical do gradiente 1",
    "Movimento horizontal do gradiente 2": "Movimento horizontal do gradiente 2",
    "Movimento vertical do gradiente 2": "Movimento vertical do gradiente 2",
    "Resetar posições": "Resetar posições",
    "Configuração dos gradientes inválida.": "Configuração dos gradientes inválida.",
    "Cor do tema": "Cor do tema",
    Roxo: "Roxo",
    "Cinza claro": "Cinza claro",
    "Cinza gelo": "Cinza gelo",
    "Cinza médio": "Cinza médio",
    "Preto suave": "Preto suave",
    "Bege claro": "Bege claro",
    Areia: "Areia",
    Branco: "Branco",
    "Azul claro": "Azul claro",
    "Verde claro": "Verde claro",
    "Violeta claro": "Violeta claro",
    "Laranja claro": "Laranja claro",
    Grafite: "Grafite",
    "Cinza escuro": "Cinza escuro",
    "Azul noite": "Azul noite",
    "Configuração da sidebar inválida.": "Configuração da sidebar inválida.",
    "Configurações de IA salvas com sucesso.": "Configurações de IA salvas com sucesso.",
    "As configurações de IA foram salvas, mas moedas e tarifas não foram alteradas porque a cobrança não pôde ser carregada.": "As configurações de IA foram salvas, mas moedas e tarifas não foram alteradas porque a cobrança não pôde ser carregada.",
    "Erro ao salvar as configurações de IA.": "Erro ao salvar as configurações de IA.",
    "Configurações de E-mail salvas com sucesso.": "Configurações de E-mail salvas com sucesso.",
    "Erro ao salvar as configurações de E-mail.": "Erro ao salvar as configurações de E-mail.",
    "Configuração Asaas salva com sucesso.": "Configuração Asaas salva com sucesso.",
    "Erro ao salvar a configuração Asaas.": "Erro ao salvar a configuração Asaas.",
    "Configuração de entrega": "Configuração de entrega",
    "Configurações de E-mail": "Configurações de E-mail",
    "Configurar email": "Configurar email",
    "Modelos de E-mail": "Modelos de E-mail",
    "Boas-vindas": "Boas-vindas",
    "Recuperação de senha": "Recuperação de senha",
    "Pedidos de insumos dos clientes": "Pedidos de insumos dos clientes",
    "Pedidos de suporte dos clientes": "Pedidos de suporte dos clientes",
    "Vencimento de insumos": "Vencimento de insumos",
    "Avisar quando um cliente enviar um novo pedido de insumos.": "Avisar quando um cliente enviar um novo pedido de insumos.",
    "Avisar quando um cliente enviar um novo pedido de suporte.": "Avisar quando um cliente enviar um novo pedido de suporte.",
    "Avisar quando um insumo estiver próximo do vencimento.": "Avisar quando um insumo estiver próximo do vencimento.",
    Favoritar: "Favoritar",
    "Remover favorito": "Remover favorito",
    "Erro ao atualizar favorito.": "Erro ao atualizar favorito.",
    "Visualize e edite os modelos usados nas notificações automáticas.": "Visualize e edite os modelos usados nas notificações automáticas.",
    "Nome do Email": "Nome do Email",
    "Tipo de email": "Tipo de email",
    "Atualizado em": "Atualizado em",
    "Nenhum modelo de e-mail encontrado": "Nenhum modelo de e-mail encontrado",
    "Ajuste a busca para localizar um modelo.": "Ajuste a busca para localizar um modelo.",
    "Buscar modelos de e-mail...": "Buscar modelos de e-mail...",
    "Editar modelo de e-mail": "Editar modelo de e-mail",
    "Personalize o conteúdo enviado aos destinatários.": "Personalize o conteúdo enviado aos destinatários.",
    "Conteúdo do e-mail": "Conteúdo do e-mail",
    "Digite o conteúdo do e-mail...": "Digite o conteúdo do e-mail...",
    "Preencha o conteúdo do e-mail.": "Preencha o conteúdo do e-mail.",
    "Erro ao carregar os modelos de e-mail.": "Erro ao carregar os modelos de e-mail.",
    "Erro ao salvar o modelo de e-mail.": "Erro ao salvar o modelo de e-mail.",
    "Modelo de e-mail atualizado com sucesso.": "Modelo de e-mail atualizado com sucesso.",
    "Marcadores obrigatórios": "Marcadores obrigatórios",
    "Esses marcadores recebem os dados do evento e não podem ser removidos.": "Esses marcadores recebem os dados do evento e não podem ser removidos.",
    "Mantenha os marcadores obrigatórios no corpo do e-mail:": "Mantenha os marcadores obrigatórios no corpo do e-mail:",
    "Defina o remetente, as respostas, o modo de teste e o endereço público usado nos links.": "Defina o remetente, as respostas, o modo de teste e o endereço público usado nos links.",
    "Remetente Resend": "Remetente Resend",
    "E-mail para respostas": "E-mail para respostas",
    "Destinatário de teste": "Destinatário de teste",
    "URL pública da plataforma": "URL pública da plataforma",
    "Ex.: Minha Empresa <notificacoes@seudominio.com>": "Ex.: Minha Empresa <notificacoes@seudominio.com>",
    "Ex.: suporte@seudominio.com": "Ex.: suporte@seudominio.com",
    "Vazio em produção": "Vazio em produção",
    "Ex.: https://app.seudominio.com": "Ex.: https://app.seudominio.com",
    "Use o remetente com um domínio verificado no Resend. Deixe o destinatário de teste vazio em produção para enviar aos destinatários reais.": "Use o remetente com um domínio verificado no Resend. Deixe o destinatário de teste vazio em produção para enviar aos destinatários reais.",
    "Salvar configuração de entrega": "Salvar configuração de entrega",
    "Configuração de entrega salva com sucesso.": "Configuração de entrega salva com sucesso.",
    "Erro ao salvar a configuração de entrega.": "Erro ao salvar a configuração de entrega.",
    "Informe um remetente válido.": "Informe um remetente válido.",
    "Informe um e-mail de resposta válido.": "Informe um e-mail de resposta válido.",
    "Informe um destinatário de teste válido.": "Informe um destinatário de teste válido.",
    "Informe uma URL pública válida.": "Informe uma URL pública válida.",
    "URL do webhook Resend": "URL do webhook Resend",
    "Copiar URL do webhook": "Copiar URL do webhook",
    "Segredo do webhook Resend": "Segredo do webhook Resend",
    "Segredo configurado": "Segredo configurado",
    "Cole o segredo whsec_ fornecido pelo Resend": "Cole o segredo whsec_ fornecido pelo Resend",
    "No Resend, adicione a URL acima ao webhook, selecione os eventos de e-mail e depois salve aqui o segredo de assinatura whsec_.": "No Resend, adicione a URL acima ao webhook, selecione os eventos de e-mail e depois salve aqui o segredo de assinatura whsec_.",
    "Eventos do webhook por organização": "Eventos do webhook por organização",
    "Totais do período para e-mails clicados, entregues, falhos e rejeitados.": "Totais do período para e-mails clicados, entregues, falhos e rejeitados.",
    Clicados: "Clicados",
    Entregues: "Entregues",
    Falhos: "Falhos",
    Rejeitados: "Rejeitados",
    "URL do webhook copiada com sucesso.": "URL do webhook copiada com sucesso.",
    "Não foi possível copiar a URL do webhook.": "Não foi possível copiar a URL do webhook.",
    "Informe um segredo de webhook Resend válido.": "Informe um segredo de webhook Resend válido.",
    "Balanço Inicial": "Balanço Inicial",
    "Produtos selecionados para contagem inicial": "Produtos selecionados para contagem inicial",
    "Iniciar contagem": "Iniciar contagem",
    "Agendas neste dia": "Agendas neste dia",
    "Dados do inventário": "Dados do inventário",
    "Data do inventário": "Data do inventário",
    "Total de itens": "Total de itens",
    "Divergência total": "Divergência total",
    Contagem: "Contagem",
    "Itens do inventário": "Itens do inventário",
    "Itens do balanço": "Itens do balanço",
    "Quantidade no sistema": "Quantidade no sistema",
    "Quantidade no balanço": "Quantidade no balanço",
    "Nenhum item encontrado": "Nenhum item encontrado",
    Sistema: "Sistema",
    Contada: "Contada",
    Diferença: "Diferença",
    "Finalizado em": "Finalizado em",
    Complementos: "Complementos",
    "Banco da venda": "Banco da venda",
    "Selecione o banco": "Selecione o banco",
    "Carregando bancos...": "Carregando bancos...",
    "Sem bancos nesta empresa": "Sem bancos nesta empresa",
    "Não foi possível carregar os bancos.": "Não foi possível carregar os bancos.",
    "Banco não encontrado para a empresa selecionada.": "Banco não encontrado para a empresa selecionada.",
    Agência: "Agência",
    Organizações: "Organizações",
    "Todas as organizações": "Todas as organizações",
    "Carregando organizações...": "Carregando organizações...",
    "Nenhuma organização encontrada para essa busca.": "Nenhuma organização encontrada para essa busca.",
    "Não foi possível carregar organizações.": "Não foi possível carregar organizações.",
    "Não foi possível trocar a organização.": "Não foi possível trocar a organização.",
    "Não foi possível trocar a empresa.": "Não foi possível trocar a empresa.",
    "Erro ao carregar o perfil.": "Erro ao carregar o perfil.",
    "Não foi possível salvar o perfil.": "Não foi possível salvar o perfil.",
    "Erro ao salvar o perfil.": "Erro ao salvar o perfil.",
    "Perfil salvo com sucesso.": "Perfil salvo com sucesso.",
    "Não foi possível remover a foto.": "Não foi possível remover a foto.",
    "Foto removida com sucesso.": "Foto removida com sucesso.",
    "Erro ao remover a foto.": "Erro ao remover a foto.",
    "Informe a senha atual e a nova senha.": "Informe a senha atual e a nova senha.",
    "A nova senha deve ter ao menos 6 caracteres.": "A nova senha deve ter ao menos 6 caracteres.",
    "Não foi possível alterar a senha.": "Não foi possível alterar a senha.",
    "Senha alterada com sucesso.": "Senha alterada com sucesso.",
    "Erro ao alterar a senha.": "Erro ao alterar a senha.",
    "Selecione uma imagem PNG ou JPG.": "Selecione uma imagem PNG ou JPG.",
    "Imagem muito grande. O limite é 8MB.": "Imagem muito grande. O limite é 8MB.",
    "Não foi possível salvar a foto.": "Não foi possível salvar a foto.",
    "Foto de perfil salva com sucesso.": "Foto de perfil salva com sucesso.",
    "Erro ao processar a foto.": "Erro ao processar a foto.",
  },
  en: {
    "Consumo de E-mails por Organização": "Email Usage by Organization",
    "Acompanhe a cota mensal usada e disponível em cada organização.": "Track the monthly quota used and available for each organization.",
    Período: "Period",
    "Total geral": "Overall total",
    Limite: "Limit",
    "Total usado": "Total used",
    "Total livre": "Total available",
    "Última alteração": "Last updated",
    "Ativar API Resend para envio de e-mails": "Enable Resend API for email delivery",
    "Quando desativada, nenhum e-mail automático será enviado.": "When disabled, no automated emails will be sent.",
    Ação: "Action",
    "Limite mensal de e-mails": "Monthly email limit",
    "Salvar limite mensal": "Save monthly limit",
    "Nenhuma organização disponível para acompanhar.": "No organization is available to track.",
    "API Resend ativada com sucesso.": "Resend API enabled successfully.",
    "API Resend desativada com sucesso.": "Resend API disabled successfully.",
    "Erro ao atualizar a API Resend.": "Could not update the Resend API.",
    "Informe um limite mensal válido.": "Enter a valid monthly limit.",
    "Erro ao salvar o limite de e-mails.": "Could not save the email limit.",
    "Limite de e-mails atualizado com sucesso.": "Email limit updated successfully.",
    Enviados: "Sent",
    Reclamados: "Complained",
    Atrasados: "Delayed",
    "Entregabilidade de E-mails": "Email Deliverability",
    "Envios e eventos do Resend por dia, nos últimos 30 dias (conta inteira).": "Resend sends and events per day, over the last 30 days (whole account).",
    "Limite Diário de Envio": "Daily Sending Limit",
    "Limite diário": "Daily limit",
    "Enviados hoje": "Sent today",
    "Restante hoje": "Remaining today",
    "Limite diário de e-mails": "Daily email limit",
    "Salvar limite diário": "Save daily limit",
    "Limite da conta Resend, compartilhado por todas as organizações. Ao ser atingido, novos envios ficam em espera até o dia seguinte para evitar erros do Resend.": "Limit for the shared Resend account, used by all organizations. Once reached, new emails wait until the next day to avoid Resend errors.",
    "Informe um limite diário válido.": "Enter a valid daily limit.",
    "Erro ao salvar o limite diário de e-mails.": "Error saving the daily email limit.",
    "Limite diário de e-mails atualizado com sucesso.": "Daily email limit updated successfully.",
    "Configure o segredo do webhook Resend acima para que os eventos de entrega, abertura e clique comecem a aparecer aqui.": "Set up the Resend webhook secret above so delivery, open, and click events start appearing here.",
    "Erro ao atualizar o envio de e-mails da organização.": "Could not update email sending for the organization.",
    "Envio de e-mails ativado para a organização.": "Email sending enabled for the organization.",
    "Envio de e-mails desativado para a organização.": "Email sending disabled for the organization.",
    "8+ Caracteres": "8+ Characters",
    "Letra Maiúscula": "Uppercase Letter",
    "Especial (!@#)": "Special (!@#)",
    "Não foi possível confirmar os dados gerais salvos no banco.": "Could not verify the general data saved in the database.",
    "Erro ao salvar a chave.": "Could not save the API key.",
    "Aparência e funcionalidades salvas com sucesso.": "Appearance and features saved successfully.",
    "Erro ao salvar aparência e funcionalidades.": "Could not save appearance and features.",
    "Cor do plano de fundo da sidebar": "Sidebar background color",
    "Opacidade do plano de fundo da sidebar": "Sidebar background opacity",
    "Gradiente do plano de fundo": "Background gradient",
    "Gradiente botões": "Button gradient",
    "Gradiente plano de fundo": "Background gradient",
    "Inverter gradiente": "Invert gradient",
    "Gradiente 1 - superior esquerdo": "Gradient 1 - top left",
    "Gradiente 2 - inferior direito": "Gradient 2 - bottom right",
    "Tamanho do gradiente 1": "Gradient 1 size",
    "Tamanho do gradiente 2": "Gradient 2 size",
    "Movimento horizontal do gradiente 1": "Gradient 1 horizontal movement",
    "Movimento vertical do gradiente 1": "Gradient 1 vertical movement",
    "Movimento horizontal do gradiente 2": "Gradient 2 horizontal movement",
    "Movimento vertical do gradiente 2": "Gradient 2 vertical movement",
    "Resetar posições": "Reset positions",
    "Configuração dos gradientes inválida.": "Invalid gradient settings.",
    "Cor do tema": "Theme color",
    Roxo: "Purple",
    "Cinza claro": "Light gray",
    "Cinza gelo": "Ice gray",
    "Cinza médio": "Medium gray",
    "Preto suave": "Soft black",
    "Bege claro": "Light beige",
    Areia: "Sand",
    Branco: "White",
    "Azul claro": "Light blue",
    "Verde claro": "Light green",
    "Violeta claro": "Light violet",
    "Laranja claro": "Light orange",
    Grafite: "Graphite",
    "Cinza escuro": "Dark gray",
    "Azul noite": "Midnight blue",
    "Configuração da sidebar inválida.": "Invalid sidebar settings.",
    "Configurações de IA salvas com sucesso.": "AI settings saved successfully.",
    "As configurações de IA foram salvas, mas moedas e tarifas não foram alteradas porque a cobrança não pôde ser carregada.": "AI settings were saved, but coins and rates were not changed because billing could not be loaded.",
    "Erro ao salvar as configurações de IA.": "Could not save the AI settings.",
    "Configurações de E-mail salvas com sucesso.": "Email settings saved successfully.",
    "Erro ao salvar as configurações de E-mail.": "Could not save the email settings.",
    "Configuração Asaas salva com sucesso.": "Asaas settings saved successfully.",
    "Erro ao salvar a configuração Asaas.": "Could not save the Asaas settings.",
    "Configuração de entrega": "Delivery settings",
    "Configurações de E-mail": "Email settings",
    "Configurar email": "Configure email",
    "Modelos de E-mail": "Email Templates",
    "Boas-vindas": "Welcome",
    "Recuperação de senha": "Password recovery",
    "Pedidos de insumos dos clientes": "Customer supply orders",
    "Pedidos de suporte dos clientes": "Customer support requests",
    "Vencimento de insumos": "Supply expiration",
    "Avisar quando um cliente enviar um novo pedido de insumos.": "Notify when a customer submits a new supply order.",
    "Avisar quando um cliente enviar um novo pedido de suporte.": "Notify when a customer submits a new support request.",
    "Avisar quando um insumo estiver próximo do vencimento.": "Notify when a supply item is nearing expiration.",
    Favoritar: "Add to favorites",
    "Remover favorito": "Remove from favorites",
    "Erro ao atualizar favorito.": "Could not update the favorite.",
    "Visualize e edite os modelos usados nas notificações automáticas.": "View and edit the templates used in automated notifications.",
    "Nome do Email": "Email name",
    "Tipo de email": "Email type",
    "Nenhum modelo de e-mail encontrado": "No email template found",
    "Ajuste a busca para localizar um modelo.": "Adjust the search to find a template.",
    "Buscar modelos de e-mail...": "Search email templates...",
    "Editar modelo de e-mail": "Edit email template",
    "Personalize o conteúdo enviado aos destinatários.": "Customize the content sent to recipients.",
    "Conteúdo do e-mail": "Email content",
    "Digite o conteúdo do e-mail...": "Enter the email content...",
    "Preencha o conteúdo do e-mail.": "Enter the email content.",
    "Erro ao carregar os modelos de e-mail.": "Could not load the email templates.",
    "Erro ao salvar o modelo de e-mail.": "Could not save the email template.",
    "Modelo de e-mail atualizado com sucesso.": "Email template updated successfully.",
    "Marcadores obrigatórios": "Required placeholders",
    "Esses marcadores recebem os dados do evento e não podem ser removidos.": "These placeholders receive the event data and cannot be removed.",
    "Mantenha os marcadores obrigatórios no corpo do e-mail:": "Keep the required placeholders in the email body:",
    "Defina o remetente, as respostas, o modo de teste e o endereço público usado nos links.": "Set the sender, reply address, test mode, and public address used in links.",
    "Remetente Resend": "Resend sender",
    "E-mail para respostas": "Reply-to email",
    "Destinatário de teste": "Test recipient",
    "URL pública da plataforma": "Platform public URL",
    "Ex.: Minha Empresa <notificacoes@seudominio.com>": "E.g.: My Company <notifications@yourdomain.com>",
    "Ex.: suporte@seudominio.com": "E.g.: support@yourdomain.com",
    "Vazio em produção": "Empty in production",
    "Ex.: https://app.seudominio.com": "E.g.: https://app.yourdomain.com",
    "Use o remetente com um domínio verificado no Resend. Deixe o destinatário de teste vazio em produção para enviar aos destinatários reais.": "Use a sender from a domain verified in Resend. Leave the test recipient empty in production to send to the actual recipients.",
    "Salvar configuração de entrega": "Save delivery settings",
    "Configuração de entrega salva com sucesso.": "Delivery settings saved successfully.",
    "Erro ao salvar a configuração de entrega.": "Could not save the delivery settings.",
    "Informe um remetente válido.": "Enter a valid sender.",
    "Informe um e-mail de resposta válido.": "Enter a valid reply-to email.",
    "Informe um destinatário de teste válido.": "Enter a valid test recipient.",
    "Informe uma URL pública válida.": "Enter a valid public URL.",
    "URL do webhook Resend": "Resend webhook URL",
    "Copiar URL do webhook": "Copy webhook URL",
    "Segredo do webhook Resend": "Resend webhook secret",
    "Segredo configurado": "Secret configured",
    "Cole o segredo whsec_ fornecido pelo Resend": "Paste the whsec_ secret provided by Resend",
    "No Resend, adicione a URL acima ao webhook, selecione os eventos de e-mail e depois salve aqui o segredo de assinatura whsec_.": "In Resend, add the URL above to the webhook, select the email events, and then save the whsec_ signing secret here.",
    "Eventos do webhook por organização": "Webhook events by organization",
    "Totais do período para e-mails clicados, entregues, falhos e rejeitados.": "Period totals for clicked, delivered, failed, and bounced emails.",
    Clicados: "Clicked",
    Entregues: "Delivered",
    Falhos: "Failed",
    Rejeitados: "Bounced",
    "URL do webhook copiada com sucesso.": "Webhook URL copied successfully.",
    "Não foi possível copiar a URL do webhook.": "Could not copy the webhook URL.",
    "Informe um segredo de webhook Resend válido.": "Enter a valid Resend webhook secret.",
    "Balanço Inicial": "Initial Inventory Count",
    "Produtos selecionados para contagem inicial": "Products selected for initial counting",
    "Iniciar contagem": "Start count",
    "Agendas neste dia": "Schedules on this day",
    "Dados do inventário": "Inventory details",
    "Data do inventário": "Inventory date",
    "Total de itens": "Total items",
    "Divergência total": "Total difference",
    Contagem: "Count",
    "Itens do inventário": "Inventory items",
    "Itens do balanço": "Inventory count items",
    "Quantidade no sistema": "System quantity",
    "Quantidade no balanço": "Counted quantity",
    "Nenhum item encontrado": "No items found",
    Sistema: "System",
    Contada: "Counted",
    Diferença: "Difference",
    "Finalizado em": "Completed at",
    Complementos: "Additional details",
    "Visão Geral": "Overview",
    Cadastros: "Registrations",
    Empresa: "Company",
    Empresas: "Companies",
    Banco: "Bank",
    Clientes: "Customers",
    Cliente: "Customer",
    Fornecedor: "Supplier",
    Fornecedores: "Suppliers",
    Transportadora: "Carrier",
    Colaborador: "Employee",
    Colaboradores: "Employees",
    Produto: "Product",
    Produtos: "Products",
    Serviço: "Service",
    Serviços: "Services",
    "Unidade de Medida": "Unit of Measure",
    Categoria: "Category",
    Categorias: "Categories",
    Armazenamento: "Warehousing",
    Tamanho: "Size",
    Cor: "Color",
    "Plano de Contas": "Chart of Accounts",
    "Maquininhas e Taxas": "Card Terminals and Fees",
    Erro: "Error",
    Serial: "Serial",
    "Perfil de Usuário": "User Profile",
    Login: "Login",
    "Pedidos de Insumo": "Supply Orders",
    "Pedidos de Suporte": "Support Orders",
    Vendas: "Sales",
    Venda: "Sale",
    Orçamentos: "Quotes",
    Orçamento: "Quote",
    Entregas: "Deliveries",
    Entrega: "Delivery",
    "Caixa PDV": "POS Register",
    Compras: "Purchases",
    Compra: "Purchase",
    Pedidos: "Orders",
    Pedido: "Order",
    Estoque: "Inventory",
    "Saldo Atual": "Current Balance",
    Movimentações: "Movements",
    Movimentação: "Movement",
    Inventário: "Inventory Count",
    Financeiro: "Finance",
    "Contas a Receber": "Accounts Receivable",
    "Vendas Parceladas": "Installment Sales",
    "Contas a Pagar": "Accounts Payable",
    "Conciliação de Cartões": "Card Reconciliation",
    "Fluxo de Caixa": "Cash Flow",
    DRE: "Income Statement",
    Suporte: "Support",
    Kanban: "Kanban",
    Calendário: "Calendar",
    "Planeje e acompanhe as tarefas de suporte por data.": "Plan and track support tasks by date.",
    "Nova tarefa": "New task",
    Chamados: "Tickets",
    Chamado: "Ticket",
    Relatórios: "Reports",
    Relatório: "Report",
    Idioma: "Language",
    Notificações: "Notifications",
    "Bloco de Notas": "Notes",
    "Minha conta": "My account",
    Ajuda: "Help",
    "Log de acesso": "Access log",
    Configurações: "Settings",
    Sair: "Sign out",
    Usuário: "User",
    "Modo Dark": "Dark Mode",
    Status: "Status",
    Disponível: "Available",
    Ausente: "Away",
    "Off-line": "Offline",
    "Acesso restrito ao dono da plataforma": "Access restricted to the platform owner",
    "Pesquisar menu": "Search menu",
    "Trocar de empresa": "Switch company",
    "Pesquisar Filial": "Search Branch",
    "Todas as empresas": "All companies",
    Organizações: "Organizations",
    "Todas as organizações": "All organizations",
    "Carregando organizações...": "Loading organizations...",
    "Nenhuma organização encontrada para essa busca.": "No organization found for this search.",
    "Não foi possível carregar organizações.": "Could not load organizations.",
    "Não foi possível trocar a organização.": "Could not switch organization.",
    "Não foi possível trocar a empresa.": "Could not switch company.",
    "Empresas da organização": "Organization companies",
    "Selecione uma organização para listar as empresas.": "Select an organization to list companies.",
    "Carregando empresas...": "Loading companies...",
    "Nenhuma empresa encontrada para essa busca.": "No company found for this search.",
    Atual: "Current",
    "Trocando...": "Switching...",
    "Erro ao carregar o perfil.": "Could not load the profile.",
    "Não foi possível salvar o perfil.": "Could not save the profile.",
    "Erro ao salvar o perfil.": "Error while saving the profile.",
    "Perfil salvo com sucesso.": "Profile saved successfully.",
    "Não foi possível remover a foto.": "Could not remove the photo.",
    "Foto removida com sucesso.": "Photo removed successfully.",
    "Erro ao remover a foto.": "Error while removing the photo.",
    "Informe a senha atual e a nova senha.": "Enter the current and new passwords.",
    "A nova senha deve ter ao menos 6 caracteres.": "The new password must be at least 6 characters long.",
    "Não foi possível alterar a senha.": "Could not change the password.",
    "Senha alterada com sucesso.": "Password changed successfully.",
    "Erro ao alterar a senha.": "Error while changing the password.",
    "Selecione uma imagem PNG ou JPG.": "Select a PNG or JPG image.",
    "Imagem muito grande. O limite é 8MB.": "The image is too large. The limit is 8 MB.",
    "Não foi possível salvar a foto.": "Could not save the photo.",
    "Foto de perfil salva com sucesso.": "Profile photo saved successfully.",
    "Erro ao processar a foto.": "Error while processing the photo.",
    "Todos os períodos": "All periods",
    "Período selecionado!": "Selected period!",
    "Assistente de IA": "AI Assistant",
    "Um ótimo domingo": "Have a great Sunday",
    Segundou: "Monday mode",
    Sextou: "Friday mode",
    "Bom dia": "Good morning",
    "Boa tarde": "Good afternoon",
    "Boa noite": "Good evening",
    hoje: "today",
    "até": "to",
    Novo: "New",
    Nova: "New",
    "Novo Produto": "New Product",
    "Nova Empresa": "New Company",
    "Nova Categoria": "New Category",
    "Adicionar categoria": "Add category",
    Cadastrar: "Register",
    Salvar: "Save",
    Cancelar: "Cancel",
    Editar: "Edit",
    Excluir: "Delete",
    Duplicar: "Duplicate",
    Exportar: "Export",
    Importar: "Import",
    Imprimir: "Print",
    Visualizar: "View",
    Tickets: "Tickets",
    "Visualizar Grade": "View Grid",
    Atualizar: "Refresh",
    Limpar: "Clear",
    Filtrar: "Filter",
    Filtros: "Filters",
    Buscar: "Search",
    Pesquisar: "Search",
    Fechar: "Close",
    Confirmar: "Confirm",
    Voltar: "Back",
    Continuar: "Continue",
    Avançar: "Next",
    Dados: "Data",
    Observação: "Notes",
    Observações: "Notes",
    "Observações...": "Notes...",
    Descrição: "Description",
    Nome: "Name",
    Ativo: "Active",
    Ativa: "Active",
    Inativo: "Inactive",
    Inativa: "Inactive",
    Obrigatório: "Required",
    "Campos obrigatórios": "Required fields",
    Email: "Email",
    "E-mail": "Email",
    Senha: "Password",
    Perfil: "Profile",
    "Empresa Principal": "Primary Company",
    "Empresas de acesso": "Access companies",
    Telefone: "Phone",
    Celular: "Mobile",
    Endereço: "Address",
    Número: "Number",
    Cidade: "City",
    Estado: "State",
    País: "Country",
    Código: "Code",
    "Código interno": "Internal code",
    "Código de barras": "Barcode",
    SKU: "SKU",
   "Estoque Mín.": "Min. Stock",
    "Estoque Min.": "Min. Stock",
    Preço: "Price",
    Custo: "Cost",
    Unidade: "Unit",
    Imagem: "Image",
    Cargo: "Role",
    Departamento: "Department",
    Funcionario: "Employee",
    Funcionário: "Employee",
    Estagiario: "Intern",
    Estagiário: "Intern",
    Terceirizado: "Outsourced",
    Autonomo: "Self-employed",
    Autônomo: "Self-employed",
    Temporario: "Temporary",
    Temporário: "Temporary",
    "Tipo do colaborador": "Employee type",
    "Tipo de colaborador": "Employee type",
    "Pessoa Física": "Individual",
    "Pessoa Juridica": "Company",
    "Pessoa Jurídica": "Company",
    Avulso: "Single",
    "Com Grade": "With grid",
    "Sem Grade": "Without grid",
    Próprio: "Own",
    Proprio: "Own",
    Expresso: "Express",
    Econômico: "Economy",
    Economico: "Economy",
    Agregado: "Aggregated",
    "Cor da Tag": "Tag color",
    "Remover tag": "Remove tag",
    "Digite e pressione Enter...": "Type and press Enter...",
    "Valor bruto": "Gross amount",
    "Valor total": "Total amount",
    "Valor recebido": "Amount received",
    "Valor da parcela": "Installment amount",
    "Valor por parcela": "Amount per installment",
    "Valor Parcelado": "Installment amount",
    "Total de parcelas": "Total installments",
    "Total com juros": "Total with interest",
    "Juros": "Interest",
    Desconto: "Discount",
    Troco: "Change",
    "Falta receber": "Remaining amount",
    "Primeiro vencimento": "First due date",
    "Status atual": "Current status",
    Parcela: "Installment",
    "Tipo do cartão": "Card type",
    "Tipo de ativação": "Activation type",
    "Prazo de ativação": "Activation deadline",
    Chave: "Key",
    Causa: "Cause",
    Solução: "Solution",
    Solucao: "Solution",
    Sabor: "Flavor",
    Volume: "Volume",
    "Preço Adicional": "Additional price",
    "Preço de Venda": "Sale price",
    "Nome do erro": "Error name",
    "Descrição do erro": "Error description",
    "Nome do caixa": "Register name",
    "Saldo de abertura": "Opening balance",
    "Data e hora do fechamento": "Closing date and time",
    "Usuário responsável": "Responsible user",
    "Fundo de caixa para manter": "Cash fund to keep",
    "Selecione a empresa primeiro": "Select the company first",
    "Sem prazo definido": "No deadline set",
    "Nao definida": "Not defined",
    "Não definida": "Not defined",
    Linhas: "Rows",
    "Produto salvo com sucesso.": "Product saved successfully.",
    "Erro interno do servidor.": "The operation could not be completed. Review the entered data and try again.",
    "Um campo do cadastro não está disponível no banco de dados.": "A field in this record is not available in the database.",
    "Código já existe.": "Code already exists.",
    "O código já existe.": "This code already exists.",
    "SKU já cadastrado.": "SKU already registered.",
    "Código SKU já cadastrado.": "SKU code already registered.",
    "Nenhum registro encontrado.": "No records found.",
    "Nenhum item encontrado.": "No item found.",
    "Carregando...": "Loading...",
    "Processando...": "Processing...",
    Bancos: "Banks",
    "Cadastro das contas bancárias vinculadas às empresas.": "Register bank accounts linked to companies.",
    "Nome do banco": "Bank name",
    "Nome do Banco": "Bank name",
    "Código do banco": "Bank code",
    "Banco da venda": "Sale bank",
    "Selecione o banco": "Select a bank",
    "Carregando bancos...": "Loading banks...",
    "Sem bancos nesta empresa": "No banks registered for this company",
    "Não foi possível carregar os bancos.": "The banks could not be loaded.",
    "Banco não encontrado para a empresa selecionada.": "Bank not found for the selected company.",
    Agência: "Branch",
    "Agência / Conta": "Branch / Account",
    "Tipo da conta": "Account type",
    "Tipo da Conta": "Account type",
    Titular: "Holder",
    "Dígito da agência": "Branch digit",
    Conta: "Account",
    "Dígito da conta": "Account digit",
    "Documento do titular": "Holder document",
    "Chave PIX": "PIX key",
    "Tipo da chave PIX": "PIX key type",
    "Banco principal": "Main bank",
    "Dados bancários": "Bank details",
    Identificação: "Identification",
    "Titular e PIX": "Holder and PIX",
    "Conta Corrente": "Checking Account",
    "Conta Poupanca": "Savings Account",
    "Conta Poupança": "Savings Account",
    Pagamentos: "Payments",
    Salario: "Salary",
    Salário: "Salary",
    Investimentos: "Investments",
    Corrente: "Checking",
    Poupanca: "Savings",
    Poupança: "Savings",
    Pagamento: "Payment",
    Investimento: "Investment",
    Outra: "Other",
    Principal: "Main",
    "Sem nome": "Unnamed",
    "Cód.": "Code",
    // Placeholder gerado pelo filtro compartilhado de descrição.
    "Buscar por descrição…": "Search by description…",
    "Buscar por nome do banco...": "Search by bank name...",
    "Buscar por nome, CNPJ, cidade...": "Search by name, CNPJ, city...",
    "Buscar por nome, equipamento...": "Search by name, equipment...",
    "Buscar por nome, SKU, categoria...": "Search by name, SKU, category...",
    "Buscar por número, origem, destino...": "Search by number, origin, destination...",
    "Buscar por nome, CPF, cargo...": "Search by name, CPF, role...",
    "Buscar por nome, CPF, cargo…": "Search by name, CPF, role...",
    "Buscar por nome, e-mail...": "Search by name, email...",
    "Nenhuma opção encontrada": "No option found",
    Baixa: "Low",
    Média: "Medium",
    Alta: "High",
    Urgente: "Urgent",
    Aberto: "Open",
    Abertos: "Open",
    Iniciado: "Started",
    Tarefas: "Tasks",
    "Em andamento": "In progress",
    Aguardando: "Waiting",
    Concluído: "Completed",
    Concluido: "Completed",
    Concluída: "Completed",
    Concluida: "Completed",
    Fechado: "Closed",
    "Nenhum chamado nesta etapa.": "No ticket in this stage.",
    "Nenhum chamado encontrado": "No ticket found",
    "Novo chamado": "New ticket",
    "Editar chamado": "Edit ticket",
    Prioridade: "Priority",
    Responsável: "Owner",
    "Responsavel": "Owner",
    Solicitante: "Requester",
    Solicitação: "Request",
    Solicitacao: "Request",
    Finalização: "Completion",
    "Finalizacao": "Completion",
    Início: "Start",
    Inicio: "Start",
    Título: "Title",
    Titulo: "Title",
    "Carregando chamados...": "Loading tickets...",
    "Abrir menu da tarefa": "Open task menu",
    "Editar tarefa": "Edit task",
    "Excluir tarefa": "Delete task",
    "Adicionar tarefa": "Add task",
    "Chamado sem titulo": "Untitled ticket",
    "Chamado sem título": "Untitled ticket",
    "Tarefa do calendário": "Calendar task",
    "Pedido do cliente": "Customer request",
    "Chamado avulso": "Standalone ticket",
    "Visualizar chamado": "View ticket",
    "Mover para": "Move to",
    "Voltar para": "Move back to",
    "Suporte — Visão Geral": "Support — Overview",
    "Suporte — Dashboard": "Support — Dashboard",
    "Login de suporte": "Support login",
    Todos: "All",
    "Visualizar tarefa": "View task",
    "Dados da tarefa": "Task details",
    "Tarefa sem título": "Untitled task",
    "Sem descrição.": "No description.",
    "Criado por": "Created by",
    Fim: "End",
   "Tempo médio de atendimento": "Average service time",
    "Resposta média do chamado": "Average ticket response",
    "Chamados sem início": "Tickets not started",
    "Mês de maior fluxo": "Busiest month",
    "Equipe de suporte": "Support team",
    "Cards por usuário com volume, tempos e itens ativos.": "User cards with volume, timing, and active items.",
    Ativos: "Active",
    Resposta: "Response",
    Atendimento: "Service",
    "Sem dados suficientes.": "Not enough data.",
    "Fluxo mensal de atendimento": "Monthly support flow",
    "Distribuição de chamados abertos nos últimos 12 meses.": "Distribution of tickets opened in the last 12 months.",
    "SLA de resposta": "Response SLA",
    "Média frente à meta de 8h.": "Average compared with the 8h target.",
    "Tickets Abertos": "Open Tickets",
    "Resolvidos Hoje": "Resolved Today",
    "SLA Médio": "Average SLA",
    "Tempo Médio de Resposta": "Average Response Time",
    "Satisfação do Cliente": "Customer Satisfaction",
    "Pesquisa de Satisfação": "Satisfaction Survey",
    "Detalhes da venda": "Sale details",
    Onboarding: "Onboarding",
    "Defina o idioma da plataforma": "Choose the platform language",
    "vs semana anterior": "vs previous week",
    "vs ontem": "vs yesterday",
    "Em Andamento": "In Progress",
    "Crítica": "Critical",
    "Evolução de Tickets": "Ticket Evolution",
    "Últimos 7 dias": "Last 7 days",
    "Últimos 14 dias": "Last 14 days",
    "Últimos 30 dias": "Last 30 days",
    "Distribuição por Prioridade": "Priority Distribution",
    "tickets": "tickets",
    "Status do Atendimento": "Service Status",
    "Novos": "New",
    "Aguardando Cliente": "Waiting for Customer",
    "Em Atendimento": "In Service",
    "Escalados": "Escalated",
    "Finalizados": "Completed",
    "Tickets Recentes": "Recent Tickets",
    "Ver todos": "View all",
    "Assunto": "Subject",
    "Canal": "Channel",
    "Ver ranking": "View ranking",
    "Última Atualização": "Last Update",
    "tickets resolvidos": "resolved tickets",
    "Resposta média": "Average response",
    "Radar do suporte": "Support radar",
    "Comparativo normalizado dos principais responsáveis.": "Normalized comparison of the main assignees.",
    "Atendimentos por suporte": "Support service by user",
    "Atendimentos": "Services",
    "Total de atendimentos por mês": "Total services by month",
    "Atendimentos de janeiro a dezembro.": "Services from January to December.",
    "Chamados concluídos, ativos e tarefas por responsável.": "Completed tickets, active tickets, and tasks by assignee.",
    "Resposta média por suporte": "Average response by support user",
    "Horas entre chegada do chamado e início do atendimento.": "Hours between ticket arrival and service start.",
    "Dashboard de Suporte": "Support Dashboard",
    "Panorama do Kanban, dos chamados e das tarefas do calendário.": "Overview of the Kanban board, tickets, and calendar tasks.",
    "Erro ao carregar a visão geral.": "Unable to load the overview.",
    "Itens do Kanban por etapa": "Kanban items by stage",
    "Chamados e tarefas no fluxo atual.": "Tickets and tasks in the current workflow.",
    "Carga ativa por responsável": "Active workload by assignee",
    "Itens ainda não concluídos.": "Items not yet completed.",
    "Tarefas do calendário por prioridade": "Calendar tasks by priority",
    "Evolução dos chamados": "Ticket trends",
    "Aberturas e conclusões nos últimos 6 meses.": "Tickets opened and completed over the last 6 months.",
    "Agenda dos próximos 7 dias": "Schedule for the next 7 days",
    "Tarefas não concluídas por data programada.": "Incomplete tasks by scheduled date.",
    "Movimentações do Kanban": "Kanban movements",
    "Atividade registrada nos últimos 14 dias.": "Activity recorded over the last 14 days.",
    "Atividade registrada nos últimos 15 dias.": "Activity recorded over the last 15 days.",
    "Sem responsável": "Unassigned",
    Concluídos: "Completed",
    "Registrar movimentação do Kanban": "Record Kanban movement",
    "Confirmar movimentação": "Confirm movement",
    "Etapa de destino": "Destination stage",
    "Informe o que foi feito ou o motivo da movimentação...": "Describe what was done or the reason for the movement...",
    "Informe o que foi feito ou o motivo da movimentação.": "Describe what was done or the reason for the movement.",
    "Não foi possível salvar um dos anexos da movimentação.": "One of the movement attachments could not be saved.",
    "Movimentação inválida para a etapa atual do Kanban.": "Invalid movement for the current Kanban stage.",
    "Carregando itens...": "Loading items...",
    "Nenhum item nesta etapa.": "No item in this stage.",
    "Linha do tempo": "Timeline",
    "Histórico do atendimento": "Support history",
    "Chamado aberto": "Ticket opened",
    "Tarefa criada": "Task created",
    "Nenhum histórico disponível.": "No history available.",
    "Etapa não utilizada.": "Stage not used.",
    "Mostrar todos os históricos": "Show all histories",
    "Mostrar somente o concluído selecionado": "Show only the selected completed item",
    "Clique em um item concluído para ver a linha do tempo.": "Click a completed item to view its timeline.",
    "Excluir chamado": "Delete ticket",
    "Registrar avanço do Kanban": "Record Kanban progress",
    "Descreva o que foi feito ou o motivo da mudança de etapa.": "Describe what was done or why the stage changed.",
    "Confirmar avanço": "Confirm progress", Item: "Item", "Próxima etapa": "Next stage", "Registro da etapa": "Stage record",
    "Informe o que foi feito ou o motivo do avanço...": "Describe what was done or why the item is advancing...",
    "Informe o que foi feito ou o motivo do avanço.": "Describe what was done or why the item is advancing.",
    "Não foi possível salvar um dos anexos do avanço.": "One of the progress attachments could not be saved.",
    "Movimentação inválida. Avance o item seguindo a sequência do Kanban.": "Invalid movement. Advance the item in the Kanban sequence.",
    "Chamados não podem ser excluídos pelo Kanban.": "Tickets cannot be deleted from the Kanban board.", "anexo(s)": "attachment(s)",
    "Movimente o chamado pelo Kanban e registre o que foi feito ou o motivo do avanço.": "Move the ticket through Kanban and record what was done or why it advanced.",
    "Item movido com sucesso.": "Item moved successfully.",
    "Não foi possível mover o item.": "The item could not be moved.",
    "Tarefa excluída com sucesso.": "Task deleted successfully.",
    "Chamado excluído com sucesso.": "Ticket deleted successfully.",
    "Não foi possível excluir o chamado.": "The ticket could not be deleted.",
    "Excluir a tarefa": "Delete task",
    "Quadro visual de tarefas, pedidos e chamados com prioridade, data de início e pessoa responsável.": "Visual board of tasks, requests, and tickets with priority, start date, and assignee.",
    "Item ou etapa do Kanban inválida.": "Invalid Kanban item or stage.",
    "Você não tem permissão para movimentar este chamado.": "You do not have permission to move this ticket.",
    "Você não tem permissão para movimentar esta tarefa.": "You do not have permission to move this task.",
    "Armazenamentos": "Warehousing",
    "Cadastro dos locais/depósitos onde os produtos são armazenados.": "Register the locations/warehouses where products are stored.",
    "Importar Armazenamentos": "Import Warehousing",
    "Categorias de Estoque": "Stock Categories",
    "Organize os produtos por categoria.": "Organize products by category.",
    "Importar Categorias de Estoque": "Import Stock Categories",
    "Unidades de Medida": "Units of Measure",
    "Cadastro das unidades de medida usadas nos produtos (UN, KG, CX…).": "Register the units of measure used by products (UN, KG, BOX...).",
    "Importar Unidades de Medida": "Import Units of Measure",
    Cores: "Colors",
    "Cadastro de cores usadas nos produtos.": "Register colors used by products.",
    Erros: "Errors",
    "Cadastro de erros técnicos: causa, solução e documentação.": "Register technical errors: cause, solution and documentation.",
    Tamanhos: "Sizes",
    "Cadastro de tamanhos (calçado, roupa, etc).": "Register sizes (shoes, clothes, etc.).",
    "Cadastro de chaves de ativação por produto.": "Register activation keys by product.",
    Classificação: "Rating",
    Tag: "Tag",
    Fantasia: "Trade name",
    Tipo: "Type",
    "Natureza Juridica": "Legal nature",
    "Razão Social": "Legal name",
    "Razao Social": "Legal name",
    "Nome / Razão Social": "Name / Legal name",
    "Tipo de Pessoa": "Person type",
    "Data de Nascimento": "Birth date",
    "Inscrição Estadual": "State registration",
    "Inscrição Municipal": "Municipal registration",
    "Inscrição SUFRAMA": "SUFRAMA registration",
    "Regime Tributário": "Tax regime",
    "Insc. Municipal": "Municipal reg.",
    "Insc. Estadual": "State reg.",
    "Nome Fantasia": "Trade name",
    "Tel. Fixo": "Landline",
    "Telefone Fixo": "Landline",
    "CNPJ/CPF": "CNPJ/CPF",
    "CNPJ / CPF": "CNPJ / CPF",
    "Atende por WhatsApp": "Available on WhatsApp",
    CEP: "ZIP code",
    Complemento: "Address line 2",
    Bairro: "District",
    Contato: "Contact",
    Site: "Website",
    "Nome do Responsável": "Owner name",
    "CPF do Responsável": "Owner CPF",
    "Cargo do Responsável": "Owner role",
    "Telefone do Responsável": "Owner phone",
    "E-mail do Responsável": "Owner email",
    "RG / Inscrição Estadual": "ID / State registration",
    "Prazo médio (dias)": "Average lead time (days)",
    "Prazo médio de entrega (dias)": "Average delivery time (days)",
    "Nome do Produto": "Product name",
    "Código SKU": "SKU code",
    "Código de Barras": "Barcode",
    "Código Externo": "External code",
    "Estoque Mínimo": "Minimum stock",
    "Estoque Máximo": "Maximum stock",
    "Custo Médio": "Average cost",
    "Custo Médio (R$)": "Average cost (R$)",
    "Preço Venda": "Sale price",
    "Preço de Venda (R$)": "Sale price (R$)",
    "Descrição Resumida": "Short description",
    "Descrição Completa": "Full description",
    "Altura (cm)": "Height (cm)",
    "Largura (cm)": "Width (cm)",
    "Comprimento (cm)": "Length (cm)",
    "Peso Bruto (kg)": "Gross weight (kg)",
    "Peso Líquido (kg)": "Net weight (kg)",
    Marca: "Brand",
    Modelo: "Model",
    Material: "Material",
    Voltagem: "Voltage",
    "Grade de Produtos": "Product Grid",
    "Criado em": "Created at",
    "Atualizado em": "Updated at",
    "Un.": "Unit",
    Valor: "Amount",
    Vencimento: "Due date",
    Forma: "Method",
    Entrada: "Inflow",
    Saida: "Outflow",
    Saída: "Outflow",
    Saldo: "Balance",
    "Forma de Pagamento": "Payment method",
    "Data da venda": "Sale date",
    Prazo: "Deadline",
    "Prazo de entrega": "Delivery deadline",
    "Data de entrega": "Delivery date",
    "Entrega confirmada": "Delivery confirmed",
    "Endereço igual ao do cliente": "Address same as customer",
    "Endereço de entrega": "Delivery address",
    Itens: "Items",
    Total: "Total",
    Caixa: "Register",
    Sim: "Yes",
    Não: "No",
    "Mapa de Clientes": "Customer Map",
    "Clientes por Estado": "Customers by State",
    "Ranking por estado": "Ranking by state",
    "Sem dados.": "No data.",
    "Carregando…": "Loading...",
    de: "of",
    "Tente outro nome, ID ou status.": "Try another name, ID, or status.",
    "Nenhum registro encontrado": "No records found",
    "Nenhum dado disponível.": "No data available.",
    "Mesclar linhas": "Merge rows",
    "Remover favoritos": "Remove favorites",
    "Selecionar todos": "Select all",
    Selecionar: "Select",
    Anterior: "Previous",
    "Próximo": "Next",
    Proximo: "Next",
    "Subir ao topo": "Back to top",
    "Fechar opções": "Close options",
    "Selecione...": "Select...",
    "Digite para filtrar...": "Type to filter...",
    "Abrir calendário": "Open calendar",
    "Alternar visualização do calendário": "Switch calendar view",
    "Selecionar horário": "Select time",
    "Cancelar seleção de horário": "Cancel time selection",
    "Confirmar seleção de horário": "Confirm time selection",
    Hora: "Hour",
    "Filtrar por": "Filter by",
    "Adicionar período": "Add period",
    "Ajustar intervalo temporal": "Adjust time range",
    "Ajustar Intervalo Temporal": "Adjust Time Range",
    "Período rápido": "Quick period",
    "Selecionar período": "Select period",
    "Início selecionado": "Start selected",
    "Escolha a data final no calendário.": "Choose the end date on the calendar.",
    "Use o calendário para escolher o início e o fim do período.": "Use the calendar to choose the start and end of the period.",
    "Esta Semana": "This Week",
    "Semana Passada": "Last Week",
    "Este Mês": "This Month",
    "Ano Passado": "Last Year",
    "Este Ano": "This Year",
    "3 Meses": "3 Months",
    "6 Meses": "6 Months",
    Personalizado: "Custom",
    Janeiro: "January",
    Fevereiro: "February",
    Março: "March",
    Abril: "April",
    Maio: "May",
    Junho: "June",
    Julho: "July",
    Agosto: "August",
    Setembro: "September",
    Outubro: "October",
    Novembro: "November",
    Dezembro: "December",
    Jan: "Jan",
    Fev: "Feb",
    Mar: "Mar",
    Abr: "Apr",
    Mai: "May",
    Jun: "Jun",
    Jul: "Jul",
    Ago: "Aug",
    Set: "Sep",
    Out: "Oct",
    Nov: "Nov",
    Dez: "Dec",
    jan: "Jan",
    fev: "Feb",
    mar: "Mar",
    abr: "Apr",
    mai: "May",
    jun: "Jun",
    jul: "Jul",
    ago: "Aug",
    set: "Sep",
    out: "Oct",
    nov: "Nov",
    dez: "Dec",
    Dom: "Sun",
    Seg: "Mon",
    Ter: "Tue",
    Qua: "Wed",
    Qui: "Thu",
    Sex: "Fri",
    Sáb: "Sat",
    Sab: "Sat",
    "Importar dados": "Import data",
    "Importe registros a partir de uma planilha .xlsx ou .csv.": "Import records from an .xlsx or .csv spreadsheet.",
    "Use um arquivo .xlsx ou .csv.": "Use an .xlsx or .csv file.",
    "Não foi possível importar.": "Could not import.",
    "Importação concluída.": "Import completed.",
    "registro(s) importado(s).": "record(s) imported.",
    "Erro ao importar.": "Error importing.",
    "Falha ao ler o arquivo.": "Failed to read the file.",
    "Clique ou arraste o arquivo .xlsx ou .csv": "Click or drag the .xlsx or .csv file",
    "Formatos aceitos: XLSX, CSV · Tamanho máximo: 25 MB": "Accepted formats: XLSX, CSV · Maximum size: 25 MB",
    "Baixe o modelo para usar como ponto de partida.": "Download the template to use as a starting point.",
    "Formatação do texto": "Text formatting",
    Negrito: "Bold",
    Itálico: "Italic",
    Sublinhado: "Underline",
    Tachado: "Strikethrough",
    "Cor do texto": "Text color",
    "Cor de realce": "Highlight color",
    "Limpar formatação": "Clear formatting",
    "Inserir imagem": "Insert image",
    "Inserir link": "Insert link",
    "Inserir tabela": "Insert table",
    "Alinhar à esquerda": "Align left",
    Centralizar: "Center",
    "Alinhar à direita": "Align right",
    Justificar: "Justify",
    "Diminuir recuo": "Decrease indent",
    "Aumentar recuo": "Increase indent",
    "Lista numerada": "Numbered list",
    "Lista com marcadores": "Bulleted list",
    "Caractere especial": "Special character",
    Emoji: "Emoji",
    "Linha horizontal": "Horizontal line",
    Fonte: "Font",
    "Tamanho da fonte": "Font size",
    "Formato do bloco": "Block format",
    Desfazer: "Undo",
    Refazer: "Redo",
    "Fonte do sistema": "System font",
    Parágrafo: "Paragraph",
    "Título 1": "Heading 1",
    "Título 2": "Heading 2",
    "Título 3": "Heading 3",
    Inserir: "Insert",
    Colunas: "Columns",
    "Observação...": "Note...",
    Lista: "List",
    Grade: "Grid",
    "Modo de visualização": "View mode",
    "Nenhuma notificação por aqui.": "No notifications here.",
    "Buscar arquivo...": "Search file...",
    "Carregando anexos...": "Loading attachments...",
    "Anexar arquivo": "Attach file",
    Enviar: "Send",
    "Nenhuma noticia disponível.": "No news available.",
    "Nenhuma notícia disponível.": "No news available.",
    "Nenhuma nota encontrada.": "No note found.",
    "Validar CEP": "Validate ZIP code",
    "Selecionar cor personalizada": "Select custom color",
    "Cor personalizada": "Custom color",
    "Menu do usuário": "User menu",
    "Editar perfil": "Edit profile",
    "Fechar tour": "Close tour",
    "Reiniciar tour guiado": "Restart guided tour",
    "Alternar menu": "Toggle menu",
    "Seu nome": "Your name",
    "Digite a senha atual": "Enter current password",
    "Digite a nova senha": "Enter new password",
    "Alterar foto de perfil": "Change profile photo",
    "Selecione a empresa...": "Select the company...",
    "Observações do lançamento…": "Entry notes...",
    "Financeiro — Receitas x Despesas": "Finance — Revenue vs Expenses",
    "Visao consolidada do período": "Consolidated view for the period",
    "Financeiro — Fluxo de caixa": "Finance — Cash flow",
    "Entradas, saidas e saldo do período": "Inflows, outflows and balance for the period",
    "Estoque — Movimentações (30 dias)": "Inventory — Movements (30 days)",
    "Entradas e saidas por dia": "Inflows and outflows by day",
    "Entradas e saídas por dia": "Inflows and outflows by day",
    "Estoque — Top produtos por saldo": "Inventory — Top products by balance",
    "Compras — Pedidos por status": "Purchases — Orders by status",
    "Compras por dia": "Purchases by day",
    "Evolucao do valor comprado por data": "Purchase value trend by date",
    "Pedidos por status": "Orders by status",
    "Compras por forma de pagamento": "Purchases by payment method",
    "Top fornecedores por volume comprado": "Top suppliers by purchased volume",
    "Distribuição dos pedidos": "Order distribution",
    "Chamados por status": "Tickets by status",
    "Por prioridade": "By priority",
    "Por categoria": "By category",
    "Faturamento por dia": "Revenue by day",
    "Evolucao das vendas registradas": "Registered sales trend",
    "Movimento do caixa PDV": "POS register movement",
    "Impacto diario das entradas e saidas": "Daily impact of inflows and outflows",
    "Quantidade de vendas por dia": "Number of sales by day",
    "Volume diario das vendas avulsas": "Daily volume of one-off sales",
    "Vendas por status": "Sales by status",
    "Receita por forma de pagamento": "Revenue by payment method",
    "Top clientes por faturamento": "Top customers by revenue",
    "Receitas × Despesas": "Revenue × Expenses",
    "Receitas por categoria": "Revenue by category",
    "Despesas por categoria": "Expenses by category",
    "Proporção do período": "Period proportion",
    "Movimentações (últimos 30 dias)": "Movements (last 30 days)",
    "Top produtos por saldo": "Top products by balance",
    "Maior giro de estoque": "Highest inventory turnover",
    "Saídas / estoque médio": "Outflows / average stock",
    "Evolução mensal": "Monthly trend",
    "Receita, despesas, CMV e lucro líquido ao longo do tempo.": "Revenue, expenses, COGS and net profit over time.",
    "Composição da DRE": "Income statement composition",
    "Participação dos principais grupos de receitas e custos.": "Share of the main revenue and cost groups.",
    Receitas: "Revenue",
    Despesas: "Expenses",
    Receita: "Revenue",
    "Lucro líquido": "Net profit",
  },
  es: {
    "Consumo de E-mails por Organização": "Consumo de correos por organización",
    "Acompanhe a cota mensal usada e disponível em cada organização.": "Controle la cuota mensual usada y disponible en cada organización.",
    Período: "Período",
    "Total geral": "Total general",
    Limite: "Límite",
    "Total usado": "Total usado",
    "Total livre": "Total disponible",
    "Última alteração": "Última modificación",
    "Ativar API Resend para envio de e-mails": "Activar la API Resend para enviar correos",
    "Quando desativada, nenhum e-mail automático será enviado.": "Cuando esté desactivada, no se enviará ningún correo automático.",
    Ação: "Acción",
    "Limite mensal de e-mails": "Límite mensual de correos",
    "Salvar limite mensal": "Guardar límite mensual",
    "Nenhuma organização disponível para acompanhar.": "No hay ninguna organización disponible para supervisar.",
    "API Resend ativada com sucesso.": "API Resend activada correctamente.",
    "API Resend desativada com sucesso.": "API Resend desactivada correctamente.",
    "Erro ao atualizar a API Resend.": "No se pudo actualizar la API Resend.",
    "Informe um limite mensal válido.": "Ingrese un límite mensual válido.",
    "Erro ao salvar o limite de e-mails.": "No se pudo guardar el límite de correos.",
    "Limite de e-mails atualizado com sucesso.": "Límite de correos actualizado correctamente.",
    Enviados: "Enviados",
    Reclamados: "Reclamados",
    Atrasados: "Retrasados",
    "Entregabilidade de E-mails": "Entregabilidad de Correos",
    "Envios e eventos do Resend por dia, nos últimos 30 dias (conta inteira).": "Envíos y eventos de Resend por día, en los últimos 30 días (cuenta completa).",
    "Limite Diário de Envio": "Límite Diario de Envío",
    "Limite diário": "Límite diario",
    "Enviados hoje": "Enviados hoy",
    "Restante hoje": "Restante hoy",
    "Limite diário de e-mails": "Límite diario de correos",
    "Salvar limite diário": "Guardar límite diario",
    "Limite da conta Resend, compartilhado por todas as organizações. Ao ser atingido, novos envios ficam em espera até o dia seguinte para evitar erros do Resend.": "Límite de la cuenta Resend, compartido por todas las organizaciones. Al alcanzarlo, los nuevos envíos esperan hasta el día siguiente para evitar errores de Resend.",
    "Informe um limite diário válido.": "Indique un límite diario válido.",
    "Erro ao salvar o limite diário de e-mails.": "Error al guardar el límite diario de correos.",
    "Limite diário de e-mails atualizado com sucesso.": "Límite diario de correos actualizado con éxito.",
    "Configure o segredo do webhook Resend acima para que os eventos de entrega, abertura e clique comecem a aparecer aqui.": "Configure el secreto del webhook de Resend arriba para que los eventos de entrega, apertura y clic empiecen a aparecer aquí.",
    "Erro ao atualizar o envio de e-mails da organização.": "No se pudo actualizar el envío de correos de la organización.",
    "Envio de e-mails ativado para a organização.": "Envío de correos activado para la organización.",
    "Envio de e-mails desativado para a organização.": "Envío de correos desactivado para la organización.",
    "8+ Caracteres": "8+ Caracteres",
    "Letra Maiúscula": "Letra Mayúscula",
    "Especial (!@#)": "Especial (!@#)",
    "Não foi possível confirmar os dados gerais salvos no banco.": "No se pudieron verificar los datos generales guardados en la base de datos.",
    "Erro ao salvar a chave.": "No se pudo guardar la clave de API.",
    "Aparência e funcionalidades salvas com sucesso.": "La apariencia y las funcionalidades se guardaron correctamente.",
    "Erro ao salvar aparência e funcionalidades.": "No se pudieron guardar la apariencia y las funcionalidades.",
    "Cor do plano de fundo da sidebar": "Color de fondo de la barra lateral",
    "Opacidade do plano de fundo da sidebar": "Opacidad del fondo de la barra lateral",
    "Gradiente do plano de fundo": "Gradiente del fondo",
    "Gradiente botões": "Gradiente de botones",
    "Gradiente plano de fundo": "Gradiente del fondo",
    "Inverter gradiente": "Invertir gradiente",
    "Gradiente 1 - superior esquerdo": "Gradiente 1 - superior izquierdo",
    "Gradiente 2 - inferior direito": "Gradiente 2 - inferior derecho",
    "Tamanho do gradiente 1": "Tamaño del gradiente 1",
    "Tamanho do gradiente 2": "Tamaño del gradiente 2",
    "Movimento horizontal do gradiente 1": "Movimiento horizontal del gradiente 1",
    "Movimento vertical do gradiente 1": "Movimiento vertical del gradiente 1",
    "Movimento horizontal do gradiente 2": "Movimiento horizontal del gradiente 2",
    "Movimento vertical do gradiente 2": "Movimiento vertical del gradiente 2",
    "Resetar posições": "Restablecer posiciones",
    "Configuração dos gradientes inválida.": "Configuración de gradientes no válida.",
    "Cor do tema": "Color del tema",
    Roxo: "Morado",
    "Cinza claro": "Gris claro",
    "Cinza gelo": "Gris hielo",
    "Cinza médio": "Gris medio",
    "Preto suave": "Negro suave",
    "Bege claro": "Beige claro",
    Areia: "Arena",
    Branco: "Blanco",
    "Azul claro": "Azul claro",
    "Verde claro": "Verde claro",
    "Violeta claro": "Violeta claro",
    "Laranja claro": "Naranja claro",
    Grafite: "Grafito",
    "Cinza escuro": "Gris oscuro",
    "Azul noite": "Azul noche",
    "Configuração da sidebar inválida.": "La configuración de la barra lateral no es válida.",
    "Configurações de IA salvas com sucesso.": "La configuración de IA se guardó correctamente.",
    "As configurações de IA foram salvas, mas moedas e tarifas não foram alteradas porque a cobrança não pôde ser carregada.": "La configuración de IA se guardó, pero las monedas y tarifas no se modificaron porque no se pudo cargar la facturación.",
    "Erro ao salvar as configurações de IA.": "No se pudo guardar la configuración de IA.",
    "Configurações de E-mail salvas com sucesso.": "La configuración de correo se guardó correctamente.",
    "Erro ao salvar as configurações de E-mail.": "No se pudo guardar la configuración de correo.",
    "Configuração Asaas salva com sucesso.": "La configuración de Asaas se guardó correctamente.",
    "Erro ao salvar a configuração Asaas.": "No se pudo guardar la configuración de Asaas.",
    "Configuração de entrega": "Configuración de entrega",
    "Configurações de E-mail": "Configuración de correo",
    "Configurar email": "Configurar correo",
    "Modelos de E-mail": "Plantillas de correo",
    "Boas-vindas": "Bienvenida",
    "Recuperação de senha": "Recuperación de contraseña",
    "Pedidos de insumos dos clientes": "Pedidos de insumos de clientes",
    "Pedidos de suporte dos clientes": "Solicitudes de soporte de clientes",
    "Vencimento de insumos": "Vencimiento de insumos",
    "Avisar quando um cliente enviar um novo pedido de insumos.": "Avisar cuando un cliente envíe un nuevo pedido de insumos.",
    "Avisar quando um cliente enviar um novo pedido de suporte.": "Avisar cuando un cliente envíe una nueva solicitud de soporte.",
    "Avisar quando um insumo estiver próximo do vencimento.": "Avisar cuando un insumo esté próximo a vencer.",
    Favoritar: "Agregar a favoritos",
    "Remover favorito": "Quitar de favoritos",
    "Erro ao atualizar favorito.": "No se pudo actualizar el favorito.",
    "Visualize e edite os modelos usados nas notificações automáticas.": "Vea y edite las plantillas usadas en las notificaciones automáticas.",
    "Nome do Email": "Nombre del correo",
    "Tipo de email": "Tipo de correo",
    "Nenhum modelo de e-mail encontrado": "No se encontró ninguna plantilla de correo",
    "Ajuste a busca para localizar um modelo.": "Ajuste la búsqueda para encontrar una plantilla.",
    "Buscar modelos de e-mail...": "Buscar plantillas de correo...",
    "Editar modelo de e-mail": "Editar plantilla de correo",
    "Personalize o conteúdo enviado aos destinatários.": "Personalice el contenido enviado a los destinatarios.",
    "Conteúdo do e-mail": "Contenido del correo",
    "Digite o conteúdo do e-mail...": "Ingrese el contenido del correo...",
    "Preencha o conteúdo do e-mail.": "Ingrese el contenido del correo.",
    "Erro ao carregar os modelos de e-mail.": "No se pudieron cargar las plantillas de correo.",
    "Erro ao salvar o modelo de e-mail.": "No se pudo guardar la plantilla de correo.",
    "Modelo de e-mail atualizado com sucesso.": "Plantilla de correo actualizada correctamente.",
    "Marcadores obrigatórios": "Marcadores obligatorios",
    "Esses marcadores recebem os dados do evento e não podem ser removidos.": "Estos marcadores reciben los datos del evento y no se pueden eliminar.",
    "Mantenha os marcadores obrigatórios no corpo do e-mail:": "Mantenga los marcadores obligatorios en el cuerpo del correo:",
    "Defina o remetente, as respostas, o modo de teste e o endereço público usado nos links.": "Defina el remitente, las respuestas, el modo de prueba y la dirección pública usada en los enlaces.",
    "Remetente Resend": "Remitente de Resend",
    "E-mail para respostas": "Correo para respuestas",
    "Destinatário de teste": "Destinatario de prueba",
    "URL pública da plataforma": "URL pública de la plataforma",
    "Ex.: Minha Empresa <notificacoes@seudominio.com>": "Ej.: Mi Empresa <notificaciones@sudominio.com>",
    "Ex.: suporte@seudominio.com": "Ej.: soporte@sudominio.com",
    "Vazio em produção": "Vacío en producción",
    "Ex.: https://app.seudominio.com": "Ej.: https://app.sudominio.com",
    "Use o remetente com um domínio verificado no Resend. Deixe o destinatário de teste vazio em produção para enviar aos destinatários reais.": "Use un remitente de un dominio verificado en Resend. Deje vacío el destinatario de prueba en producción para enviar a los destinatarios reales.",
    "Salvar configuração de entrega": "Guardar configuración de entrega",
    "Configuração de entrega salva com sucesso.": "Configuración de entrega guardada correctamente.",
    "Erro ao salvar a configuração de entrega.": "No se pudo guardar la configuración de entrega.",
    "Informe um remetente válido.": "Ingrese un remitente válido.",
    "Informe um e-mail de resposta válido.": "Ingrese un correo de respuesta válido.",
    "Informe um destinatário de teste válido.": "Ingrese un destinatario de prueba válido.",
    "Informe uma URL pública válida.": "Ingrese una URL pública válida.",
    "URL do webhook Resend": "URL del webhook de Resend",
    "Copiar URL do webhook": "Copiar URL del webhook",
    "Segredo do webhook Resend": "Secreto del webhook de Resend",
    "Segredo configurado": "Secreto configurado",
    "Cole o segredo whsec_ fornecido pelo Resend": "Pegue el secreto whsec_ proporcionado por Resend",
    "No Resend, adicione a URL acima ao webhook, selecione os eventos de e-mail e depois salve aqui o segredo de assinatura whsec_.": "En Resend, agregue la URL anterior al webhook, seleccione los eventos de correo y luego guarde aquí el secreto de firma whsec_.",
    "Eventos do webhook por organização": "Eventos del webhook por organización",
    "Totais do período para e-mails clicados, entregues, falhos e rejeitados.": "Totales del período para correos pulsados, entregados, fallidos y rechazados.",
    Clicados: "Pulsados",
    Entregues: "Entregados",
    Falhos: "Fallidos",
    Rejeitados: "Rechazados",
    "URL do webhook copiada com sucesso.": "URL del webhook copiada correctamente.",
    "Não foi possível copiar a URL do webhook.": "No se pudo copiar la URL del webhook.",
    "Informe um segredo de webhook Resend válido.": "Ingrese un secreto de webhook de Resend válido.",
    "Balanço Inicial": "Balance Inicial",
    "Produtos selecionados para contagem inicial": "Productos seleccionados para el conteo inicial",
    "Iniciar contagem": "Iniciar conteo",
    "Agendas neste dia": "Agendas de este día",
    "Dados do inventário": "Datos del inventario",
    "Data do inventário": "Fecha del inventario",
    "Total de itens": "Total de artículos",
    "Divergência total": "Diferencia total",
    Contagem: "Conteo",
    "Itens do inventário": "Artículos del inventario",
    "Itens do balanço": "Artículos del balance",
    "Quantidade no sistema": "Cantidad en el sistema",
    "Quantidade no balanço": "Cantidad contabilizada",
    "Nenhum item encontrado": "No se encontraron artículos",
    Sistema: "Sistema",
    Contada: "Contada",
    Diferença: "Diferencia",
    "Finalizado em": "Finalizado el",
    Complementos: "Complementos",
    "Visão Geral": "Vista general",
    Cadastros: "Registros",
    Empresa: "Empresa",
    Empresas: "Empresas",
    Banco: "Banco",
    Clientes: "Clientes",
    Cliente: "Cliente",
    Fornecedor: "Proveedor",
    Fornecedores: "Proveedores",
    Transportadora: "Transportista",
    Colaborador: "Colaborador",
    Colaboradores: "Colaboradores",
    Produto: "Producto",
    Produtos: "Productos",
    Serviço: "Servicio",
    Serviços: "Servicios",
    "Unidade de Medida": "Unidad de medida",
    Categoria: "Categoría",
    Categorias: "Categorías",
    Armazenamento: "Almacenamiento",
    Tamanho: "Tamaño",
    Cor: "Color",
    "Plano de Contas": "Plan de cuentas",
    "Maquininhas e Taxas": "Terminales y tasas",
    Erro: "Error",
    Serial: "Serial",
    "Perfil de Usuário": "Perfil de usuario",
    Login: "Login",
    "Pedidos de Insumo": "Pedidos de insumos",
    "Pedidos de Suporte": "Pedidos de soporte",
    Vendas: "Ventas",
    Venda: "Venta",
    Orçamentos: "Presupuestos",
    Orçamento: "Presupuesto",
    Entregas: "Entregas",
    Entrega: "Entrega",
    "Caixa PDV": "Caja PDV",
    Compras: "Compras",
    Compra: "Compra",
    Pedidos: "Pedidos",
    Pedido: "Pedido",
    Estoque: "Inventario",
    "Saldo Atual": "Saldo actual",
    Movimentações: "Movimientos",
    Movimentação: "Movimiento",
    Inventário: "Inventario físico",
    Financeiro: "Finanzas",
    "Contas a Receber": "Cuentas por cobrar",
    "Vendas Parceladas": "Ventas en cuotas",
    "Contas a Pagar": "Cuentas por pagar",
    "Conciliação de Cartões": "Conciliación de tarjetas",
    "Fluxo de Caixa": "Flujo de caja",
    DRE: "Estado de resultados",
    Suporte: "Soporte",
    Kanban: "Kanban",
    Calendário: "Calendario",
    "Planeje e acompanhe as tarefas de suporte por data.": "Planifique y acompañe las tareas de soporte por fecha.",
    "Nova tarefa": "Nueva tarea",
    Chamados: "Tickets",
    Chamado: "Ticket",
    Relatórios: "Informes",
    Relatório: "Informe",
    Idioma: "Idioma",
    Notificações: "Notificaciones",
    "Bloco de Notas": "Bloc de notas",
    "Minha conta": "Mi cuenta",
    Ajuda: "Ayuda",
    "Log de acesso": "Registro de acceso",
    Configurações: "Configuración",
    Sair: "Salir",
    Usuário: "Usuario",
    "Modo Dark": "Modo oscuro",
    Status: "Estado",
    Disponível: "Disponible",
    Ausente: "Ausente",
    "Off-line": "Desconectado",
    "Acesso restrito ao dono da plataforma": "Acceso restringido al propietario de la plataforma",
    "Pesquisar menu": "Buscar menú",
    "Trocar de empresa": "Cambiar de empresa",
    "Pesquisar Filial": "Buscar sucursal",
    "Todas as empresas": "Todas las empresas",
    Organizações: "Organizaciones",
    "Todas as organizações": "Todas las organizaciones",
    "Carregando organizações...": "Cargando organizaciones...",
    "Nenhuma organização encontrada para essa busca.": "No se encontró ninguna organización para esta búsqueda.",
    "Não foi possível carregar organizações.": "No se pudieron cargar las organizaciones.",
    "Não foi possível trocar a organização.": "No se pudo cambiar de organización.",
    "Não foi possível trocar a empresa.": "No se pudo cambiar de empresa.",
    "Empresas da organização": "Empresas de la organización",
    "Selecione uma organização para listar as empresas.": "Selecciona una organización para listar las empresas.",
    "Carregando empresas...": "Cargando empresas...",
    "Nenhuma empresa encontrada para essa busca.": "No se encontró ninguna empresa para esta búsqueda.",
    Atual: "Actual",
    "Trocando...": "Cambiando...",
    "Erro ao carregar o perfil.": "Error al cargar el perfil.",
    "Não foi possível salvar o perfil.": "No se pudo guardar el perfil.",
    "Erro ao salvar o perfil.": "Error al guardar el perfil.",
    "Perfil salvo com sucesso.": "Perfil guardado correctamente.",
    "Não foi possível remover a foto.": "No se pudo eliminar la foto.",
    "Foto removida com sucesso.": "Foto eliminada correctamente.",
    "Erro ao remover a foto.": "Error al eliminar la foto.",
    "Informe a senha atual e a nova senha.": "Ingresa la contraseña actual y la nueva.",
    "A nova senha deve ter ao menos 6 caracteres.": "La nueva contraseña debe tener al menos 6 caracteres.",
    "Não foi possível alterar a senha.": "No se pudo cambiar la contraseña.",
    "Senha alterada com sucesso.": "Contraseña cambiada correctamente.",
    "Erro ao alterar a senha.": "Error al cambiar la contraseña.",
    "Selecione uma imagem PNG ou JPG.": "Selecciona una imagen PNG o JPG.",
    "Imagem muito grande. O limite é 8MB.": "La imagen es demasiado grande. El límite es de 8 MB.",
    "Não foi possível salvar a foto.": "No se pudo guardar la foto.",
    "Foto de perfil salva com sucesso.": "Foto de perfil guardada correctamente.",
    "Erro ao processar a foto.": "Error al procesar la foto.",
    "Todos os períodos": "Todos los períodos",
    "Período selecionado!": "Período seleccionado!",
    "Assistente de IA": "Asistente de IA",
    "Um ótimo domingo": "Que tengas un excelente domingo",
    Segundou: "Lunes otra vez",
    Sextou: "Viernes al fin",
    "Bom dia": "Buenos días",
    "Boa tarde": "Buenas tardes",
    "Boa noite": "Buenas noches",
    hoje: "hoy",
    "até": "hasta",
    Novo: "Nuevo",
    Nova: "Nueva",
    "Novo Produto": "Nuevo producto",
    "Nova Empresa": "Nueva empresa",
    "Nova Categoria": "Nueva categoría",
    "Adicionar categoria": "Agregar categoría",
    Cadastrar: "Registrar",
    Salvar: "Guardar",
    Cancelar: "Cancelar",
    Editar: "Editar",
    Excluir: "Eliminar",
    Duplicar: "Duplicar",
    Exportar: "Exportar",
    Importar: "Importar",
    Imprimir: "Imprimir",
    Visualizar: "Ver",
    Tickets: "Tickets",
    "Visualizar Grade": "Ver cuadrícula",
    Atualizar: "Actualizar",
    Limpar: "Limpiar",
    Filtrar: "Filtrar",
    Filtros: "Filtros",
    Buscar: "Buscar",
    Pesquisar: "Buscar",
    Fechar: "Cerrar",
    Confirmar: "Confirmar",
    Voltar: "Volver",
    Continuar: "Continuar",
    Avançar: "Siguiente",
    Dados: "Datos",
    Observação: "Observación",
    Observações: "Observaciones",
    "Observações...": "Observaciones...",
    Descrição: "Descripción",
    Nome: "Nombre",
    Ativo: "Activo",
    Ativa: "Activa",
    Inativo: "Inactivo",
    Inativa: "Inactiva",
    Obrigatório: "Obligatorio",
    "Campos obrigatórios": "Campos obligatorios",
    Email: "Correo",
    "E-mail": "Correo",
    Senha: "Contraseña",
    Perfil: "Perfil",
    "Empresa Principal": "Empresa principal",
    "Empresas de acesso": "Empresas de acceso",
    Telefone: "Teléfono",
    Celular: "Móvil",
    Endereço: "Dirección",
    Número: "Número",
    Cidade: "Ciudad",
    Estado: "Estado",
    País: "País",
    Código: "Código",
    "Código interno": "Código interno",
    "Código de barras": "Código de barras",
    SKU: "SKU",
    Tags: "Tags",
    "Estoque Mín.": "Stock mín.",
    "Estoque Min.": "Stock mín.",
    Preço: "Precio",
    Custo: "Costo",
    Unidade: "Unidad",
    Imagem: "Imagen",
    Cargo: "Cargo",
    Departamento: "Departamento",
    Funcionario: "Empleado",
    Funcionário: "Empleado",
    Estagiario: "Pasante",
    Estagiário: "Pasante",
    Terceirizado: "Tercerizado",
    Autonomo: "Autónomo",
    Autônomo: "Autónomo",
    Temporario: "Temporal",
    Temporário: "Temporal",
    "Tipo do colaborador": "Tipo de colaborador",
    "Tipo de colaborador": "Tipo de colaborador",
    "Pessoa Física": "Persona física",
    "Pessoa Juridica": "Persona jurídica",
    "Pessoa Jurídica": "Persona jurídica",
    Avulso: "Eventual",
    "Com Grade": "Con cuadrícula",
    "Sem Grade": "Sin cuadrícula",
    Próprio: "Propio",
    Proprio: "Propio",
    Expresso: "Exprés",
    Econômico: "Económico",
    Economico: "Económico",
    Agregado: "Agregado",
    "Cor da Tag": "Color de etiqueta",
    "Remover tag": "Quitar etiqueta",
    "Digite e pressione Enter...": "Escriba y presione Enter...",
    "Valor bruto": "Valor bruto",
    "Valor total": "Valor total",
    "Valor recebido": "Valor recibido",
    "Valor da parcela": "Valor de la cuota",
    "Valor por parcela": "Valor por cuota",
    "Valor Parcelado": "Valor en cuotas",
    "Total de parcelas": "Total de cuotas",
    "Total com juros": "Total con intereses",
    "Juros": "Intereses",
    Desconto: "Descuento",
    Troco: "Cambio",
    "Falta receber": "Falta recibir",
    "Primeiro vencimento": "Primer vencimiento",
    "Status atual": "Estado actual",
    Parcela: "Cuota",
    "Tipo do cartão": "Tipo de tarjeta",
    "Tipo de ativação": "Tipo de activación",
    "Prazo de ativação": "Plazo de activación",
    Chave: "Clave",
    Causa: "Causa",
    Solução: "Solución",
    Solucao: "Solución",
    Sabor: "Sabor",
    Volume: "Volumen",
    "Preço Adicional": "Precio adicional",
    "Preço de Venda": "Precio de venta",
    "Nome do erro": "Nombre del error",
    "Descrição do erro": "Descripción del error",
    "Nome do caixa": "Nombre de caja",
    "Saldo de abertura": "Saldo de apertura",
    "Data e hora do fechamento": "Fecha y hora de cierre",
    "Usuário responsável": "Usuario responsable",
    "Fundo de caixa para manter": "Fondo de caja a mantener",
    "Selecione a empresa primeiro": "Seleccione la empresa primero",
    "Sem prazo definido": "Sin plazo definido",
    "Nao definida": "No definida",
    "Não definida": "No definida",
    Linhas: "Filas",
    "Produto salvo com sucesso.": "Producto guardado correctamente.",
    "Erro interno do servidor.": "No se pudo completar la operación. Revise los datos e inténtelo de nuevo.",
    "Um campo do cadastro não está disponível no banco de dados.": "Un campo de este registro no está disponible en la base de datos.",
    "Código já existe.": "El código ya existe.",
    "O código já existe.": "Este código ya existe.",
    "SKU já cadastrado.": "SKU ya registrado.",
    "Código SKU já cadastrado.": "Código SKU ya registrado.",
    "Nenhum registro encontrado.": "No se encontraron registros.",
    "Nenhum item encontrado.": "No se encontró ningún elemento.",
    "Carregando...": "Cargando...",
    "Processando...": "Procesando...",
    Bancos: "Bancos",
    "Cadastro das contas bancárias vinculadas às empresas.": "Registro de cuentas bancarias vinculadas a las empresas.",
    "Nome do banco": "Nombre del banco",
    "Nome do Banco": "Nombre del banco",
    "Código do banco": "Código del banco",
    "Banco da venda": "Banco de la venta",
    "Selecione o banco": "Seleccione un banco",
    "Carregando bancos...": "Cargando bancos...",
    "Sem bancos nesta empresa": "No hay bancos registrados para esta empresa",
    "Não foi possível carregar os bancos.": "No se pudieron cargar los bancos.",
    "Banco não encontrado para a empresa selecionada.": "Banco no encontrado para la empresa seleccionada.",
    Agência: "Agencia",
    "Agência / Conta": "Agencia / Cuenta",
    "Tipo da conta": "Tipo de cuenta",
    "Tipo da Conta": "Tipo de cuenta",
    Titular: "Titular",
    "Dígito da agência": "Dígito de agencia",
    Conta: "Cuenta",
    "Dígito da conta": "Dígito de cuenta",
    "Documento do titular": "Documento del titular",
    "Chave PIX": "Clave PIX",
    "Tipo da chave PIX": "Tipo de clave PIX",
    "Banco principal": "Banco principal",
    "Dados bancários": "Datos bancarios",
    Identificação: "Identificación",
    "Titular e PIX": "Titular y PIX",
    "Conta Corrente": "Cuenta corriente",
    "Conta Poupanca": "Cuenta de ahorros",
    "Conta Poupança": "Cuenta de ahorros",
    Pagamentos: "Pagos",
    Salario: "Salario",
    Salário: "Salario",
    Investimentos: "Inversiones",
    Corrente: "Corriente",
    Poupanca: "Ahorros",
    Poupança: "Ahorros",
    Pagamento: "Pago",
    Investimento: "Inversión",
    Outra: "Otra",
    Principal: "Principal",
    "Sem nome": "Sin nombre",
    "Cód.": "Cód.",
    "Buscar por descrição…": "Buscar por descripción…",
    "Buscar por nome do banco...": "Buscar por nombre del banco...",
    "Buscar por nome, CNPJ, cidade...": "Buscar por nombre, CNPJ, ciudad...",
    "Buscar por nome, equipamento...": "Buscar por nombre, equipo...",
    "Buscar por nome, SKU, categoria...": "Buscar por nombre, SKU, categoría...",
    "Buscar por número, origem, destino...": "Buscar por número, origen, destino...",
    "Buscar por nome, CPF, cargo...": "Buscar por nombre, CPF, cargo...",
    "Buscar por nome, CPF, cargo…": "Buscar por nombre, CPF, cargo...",
    "Buscar por nome, e-mail...": "Buscar por nombre, correo...",
    "Nenhuma opção encontrada": "No se encontró ninguna opción",
    Baixa: "Baja",
    Média: "Media",
    Alta: "Alta",
    Urgente: "Urgente",
    Aberto: "Abierto",
    Abertos: "Abiertos",
    Iniciado: "Iniciado",
    Tarefas: "Tareas",
    "Em andamento": "En curso",
    Aguardando: "En espera",
    Concluído: "Concluido",
    Concluido: "Concluido",
    Concluída: "Concluida",
    Concluida: "Concluida",
    Fechado: "Cerrado",
    "Nenhum chamado nesta etapa.": "No hay tickets en esta etapa.",
    "Nenhum chamado encontrado": "No se encontró ningún ticket",
    "Novo chamado": "Nuevo ticket",
    "Editar chamado": "Editar ticket",
    Prioridade: "Prioridad",
    Responsável: "Responsable",
    "Responsavel": "Responsable",
    Solicitante: "Solicitante",
    Solicitação: "Solicitud",
    Solicitacao: "Solicitud",
    Finalização: "Finalización",
    "Finalizacao": "Finalización",
    Início: "Inicio",
    Inicio: "Inicio",
    Título: "Título",
    Titulo: "Título",
    "Carregando chamados...": "Cargando tickets...",
    "Abrir menu da tarefa": "Abrir menú de la tarea",
    "Editar tarefa": "Editar tarea",
    "Excluir tarefa": "Eliminar tarea",
    "Adicionar tarefa": "Agregar tarea",
    "Chamado sem titulo": "Ticket sin título",
    "Chamado sem título": "Ticket sin título",
    "Tarefa do calendário": "Tarea del calendario",
    "Pedido do cliente": "Solicitud del cliente",
    "Chamado avulso": "Ticket independiente",
    "Visualizar chamado": "Ver ticket",
    "Mover para": "Mover a",
    "Voltar para": "Volver a",
    "Suporte — Visão Geral": "Soporte — Visión general",
    "Suporte — Dashboard": "Soporte — Dashboard",
    "Login de suporte": "Login de soporte",
    Todos: "Todos",
    "Visualizar tarefa": "Ver tarea",
    "Dados da tarefa": "Datos de la tarea",
    "Tarefa sem título": "Tarea sin título",
    "Sem descrição.": "Sin descripción.",
    "Criado por": "Creado por",
    Fim: "Fin",
    "Tempo médio de atendimento": "Tiempo medio de atención",
    "Resposta média do chamado": "Respuesta media del ticket",
    "Chamados sem início": "Tickets sin iniciar",
    "Mês de maior fluxo": "Mes de mayor flujo",
    "Equipe de suporte": "Equipo de soporte",
    "Cards por usuário com volume, tempos e itens ativos.": "Tarjetas por usuario con volumen, tiempos e ítems activos.",
    Ativos: "Activos",
    Resposta: "Respuesta",
    Atendimento: "Atención",
    "Sem dados suficientes.": "No hay datos suficientes.",
    "Fluxo mensal de atendimento": "Flujo mensual de atención",
    "Distribuição de chamados abertos nos últimos 12 meses.": "Distribución de tickets abiertos en los últimos 12 meses.",
    "SLA de resposta": "SLA de respuesta",
    "Média frente à meta de 8h.": "Media frente a la meta de 8h.",
    "Tickets Abertos": "Tickets abiertos",
    "Resolvidos Hoje": "Resueltos hoy",
    "SLA Médio": "SLA medio",
    "Tempo Médio de Resposta": "Tiempo medio de respuesta",
    "Satisfação do Cliente": "Satisfacción del cliente",
    "Pesquisa de Satisfação": "Encuesta de satisfacción",
    "Detalhes da venda": "Detalles de la venta",
    Onboarding: "Introducción guiada",
    "Defina o idioma da plataforma": "Define el idioma de la plataforma",
    "vs semana anterior": "vs semana anterior",
    "vs ontem": "vs ayer",
    "Em Andamento": "En curso",
    "Crítica": "Crítica",
    "Evolução de Tickets": "Evolución de Tickets",
    "Últimos 7 dias": "Últimos 7 días",
    "Últimos 14 dias": "Últimos 14 días",
    "Últimos 30 dias": "Últimos 30 días",
    "Distribuição por Prioridade": "Distribución por prioridad",
    "tickets": "tickets",
    "Status do Atendimento": "Estado de atención",
    "Novos": "Nuevos",
    "Aguardando Cliente": "Esperando cliente",
    "Em Atendimento": "En atención",
    "Escalados": "Escalados",
    "Finalizados": "Finalizados",
    "Tickets Recentes": "Tickets recientes",
    "Ver todos": "Ver todos",
    "Assunto": "Asunto",
    "Canal": "Canal",
    "Ver ranking": "Ver ranking",
    "tickets resolvidos": "tickets resueltos",
    "Última Atualização": "Última actualización",
    "Resposta média": "Respuesta media",
    "Radar do suporte": "Radar de soporte",
    "Comparativo normalizado dos principais responsáveis.": "Comparativo normalizado de los principales responsables.",
    "Atendimentos por suporte": "Atenciones por soporte",
    "Atendimentos": "Atenciones",
    "Total de atendimentos por mês": "Total de atenciones por mes",
    "Atendimentos de janeiro a dezembro.": "Atenciones de enero a diciembre.",
    "Chamados concluídos, ativos e tarefas por responsável.": "Tickets concluidos, activos y tareas por responsable.",
    "Resposta média por suporte": "Respuesta media por soporte",
    "Horas entre chegada do chamado e início do atendimento.": "Horas entre la llegada del ticket y el inicio de la atención.",
    "Dashboard de Suporte": "Panel de Soporte",
    "Panorama do Kanban, dos chamados e das tarefas do calendário.": "Panorama del Kanban, los tickets y las tareas del calendario.",
    "Erro ao carregar a visão geral.": "No se pudo cargar la visión general.",
    "Itens do Kanban por etapa": "Elementos del Kanban por etapa",
    "Chamados e tarefas no fluxo atual.": "Tickets y tareas en el flujo actual.",
    "Carga ativa por responsável": "Carga activa por responsable",
    "Itens ainda não concluídos.": "Elementos aún no completados.",
    "Tarefas do calendário por prioridade": "Tareas del calendario por prioridad",
    "Evolução dos chamados": "Evolución de los tickets",
    "Aberturas e conclusões nos últimos 6 meses.": "Tickets abiertos y completados en los últimos 6 meses.",
    "Agenda dos próximos 7 dias": "Agenda de los próximos 7 días",
    "Tarefas não concluídas por data programada.": "Tareas no completadas por fecha programada.",
    "Movimentações do Kanban": "Movimientos del Kanban",
    "Atividade registrada nos últimos 14 dias.": "Actividad registrada en los últimos 14 días.",
    "Atividade registrada nos últimos 15 dias.": "Actividad registrada en los últimos 15 días.",
    "Sem responsável": "Sin responsable",
    Concluídos: "Completados",
    "Registrar movimentação do Kanban": "Registrar movimiento del Kanban",
    "Confirmar movimentação": "Confirmar movimiento",
    "Etapa de destino": "Etapa de destino",
    "Informe o que foi feito ou o motivo da movimentação...": "Describa lo realizado o el motivo del movimiento...",
    "Informe o que foi feito ou o motivo da movimentação.": "Describa lo realizado o el motivo del movimiento.",
    "Não foi possível salvar um dos anexos da movimentação.": "No se pudo guardar uno de los archivos adjuntos del movimiento.",
    "Movimentação inválida para a etapa atual do Kanban.": "Movimiento no válido para la etapa actual del Kanban.",
    "Carregando itens...": "Cargando elementos...",
    "Nenhum item nesta etapa.": "No hay elementos en esta etapa.",
    "Linha do tempo": "Línea de tiempo",
    "Histórico do atendimento": "Historial de atención",
    "Chamado aberto": "Ticket abierto",
    "Tarefa criada": "Tarea creada",
    "Nenhum histórico disponível.": "No hay historial disponible.",
    "Etapa não utilizada.": "Etapa no utilizada.",
    "Mostrar todos os históricos": "Mostrar todos los historiales",
    "Mostrar somente o concluído selecionado": "Mostrar solo el elemento completado seleccionado",
    "Clique em um item concluído para ver a linha do tempo.": "Haga clic en un elemento completado para ver su cronología.",
    "Excluir chamado": "Eliminar ticket",
    "Registrar avanço do Kanban": "Registrar avance del Kanban",
    "Descreva o que foi feito ou o motivo da mudança de etapa.": "Describa lo realizado o el motivo del cambio de etapa.",
    "Confirmar avanço": "Confirmar avance", Item: "Elemento", "Próxima etapa": "Siguiente etapa", "Registro da etapa": "Registro de la etapa",
    "Informe o que foi feito ou o motivo do avanço...": "Indique lo realizado o el motivo del avance...",
    "Informe o que foi feito ou o motivo do avanço.": "Indique lo realizado o el motivo del avance.",
    "Não foi possível salvar um dos anexos do avanço.": "No se pudo guardar uno de los archivos adjuntos del avance.",
    "Movimentação inválida. Avance o item seguindo a sequência do Kanban.": "Movimiento no válido. Avance el elemento siguiendo la secuencia del Kanban.",
    "Chamados não podem ser excluídos pelo Kanban.": "Los tickets no pueden eliminarse desde el Kanban.", "anexo(s)": "archivo(s) adjunto(s)",
    "Movimente o chamado pelo Kanban e registre o que foi feito ou o motivo do avanço.": "Mueva el ticket por el Kanban y registre lo realizado o el motivo del avance.",
    "Item movido com sucesso.": "Elemento movido correctamente.",
    "Não foi possível mover o item.": "No se pudo mover el elemento.",
    "Tarefa excluída com sucesso.": "Tarea eliminada correctamente.",
    "Chamado excluído com sucesso.": "Ticket eliminado correctamente.",
    "Não foi possível excluir o chamado.": "No se pudo eliminar el ticket.",
    "Excluir a tarefa": "Eliminar tarea",
    "Quadro visual de tarefas, pedidos e chamados com prioridade, data de início e pessoa responsável.": "Tablero visual de tareas, solicitudes y tickets con prioridad, fecha de inicio y responsable.",
    "Item ou etapa do Kanban inválida.": "Elemento o etapa de Kanban no válida.",
    "Você não tem permissão para movimentar este chamado.": "No tiene permiso para mover este ticket.",
    "Você não tem permissão para movimentar esta tarefa.": "No tiene permiso para mover esta tarea.",
    "Armazenamentos": "Almacenamientos",
    "Cadastro dos locais/depósitos onde os produtos são armazenados.": "Registro de ubicaciones/depósitos donde se almacenan los productos.",
    "Importar Armazenamentos": "Importar almacenamientos",
    "Categorias de Estoque": "Categorías de inventario",
    "Organize os produtos por categoria.": "Organiza los productos por categoría.",
    "Importar Categorias de Estoque": "Importar categorías de inventario",
    "Unidades de Medida": "Unidades de medida",
    "Cadastro das unidades de medida usadas nos produtos (UN, KG, CX…).": "Registro de unidades de medida usadas en los productos (UN, KG, CAJ...).",
    "Importar Unidades de Medida": "Importar unidades de medida",
    Cores: "Colores",
    "Cadastro de cores usadas nos produtos.": "Registro de colores usados en los productos.",
    Erros: "Errores",
    "Cadastro de erros técnicos: causa, solução e documentação.": "Registro de errores técnicos: causa, solución y documentación.",
    Tamanhos: "Tamaños",
    "Cadastro de tamanhos (calçado, roupa, etc).": "Registro de tamaños (calzado, ropa, etc.).",
    "Cadastro de chaves de ativação por produto.": "Registro de claves de activación por producto.",
    Classificação: "Clasificación",
    Tag: "Etiqueta",
    Fantasia: "Nombre comercial",
    Tipo: "Tipo",
    "Natureza Juridica": "Naturaleza jurídica",
    "Razão Social": "Razón social",
    "Razao Social": "Razón social",
    "Nome / Razão Social": "Nombre / Razón social",
    "Tipo de Pessoa": "Tipo de persona",
    "Data de Nascimento": "Fecha de nacimiento",
    "Inscrição Estadual": "Inscripción estatal",
    "Inscrição Municipal": "Inscripción municipal",
    "Inscrição SUFRAMA": "Inscripción SUFRAMA",
    "Regime Tributário": "Régimen tributario",
    "Insc. Municipal": "Insc. municipal",
    "Insc. Estadual": "Insc. estatal",
    "Nome Fantasia": "Nombre comercial",
    "Tel. Fixo": "Teléfono fijo",
    "Telefone Fixo": "Teléfono fijo",
    "CNPJ/CPF": "CNPJ/CPF",
    "CNPJ / CPF": "CNPJ / CPF",
    "Atende por WhatsApp": "Atiende por WhatsApp",
    CEP: "Código postal",
    Complemento: "Complemento",
    Bairro: "Barrio",
    Contato: "Contacto",
    Site: "Sitio web",
    "Nome do Responsável": "Nombre del responsable",
    "CPF do Responsável": "CPF del responsable",
    "Cargo do Responsável": "Cargo del responsable",
    "Telefone do Responsável": "Teléfono del responsable",
    "E-mail do Responsável": "Correo del responsable",
    "RG / Inscrição Estadual": "RG / Inscripción estatal",
    "Prazo médio (dias)": "Plazo promedio (días)",
    "Prazo médio de entrega (dias)": "Plazo promedio de entrega (días)",
    "Nome do Produto": "Nombre del producto",
    "Código SKU": "Código SKU",
    "Código de Barras": "Código de barras",
    "Código Externo": "Código externo",
    "Estoque Mínimo": "Stock mínimo",
    "Estoque Máximo": "Stock máximo",
    "Custo Médio": "Costo promedio",
    "Custo Médio (R$)": "Costo promedio (R$)",
    "Preço Venda": "Precio de venta",
    "Preço de Venda (R$)": "Precio de venta (R$)",
    "Descrição Resumida": "Descripción breve",
    "Descrição Completa": "Descripción completa",
    "Altura (cm)": "Altura (cm)",
    "Largura (cm)": "Ancho (cm)",
    "Comprimento (cm)": "Largo (cm)",
    "Peso Bruto (kg)": "Peso bruto (kg)",
    "Peso Líquido (kg)": "Peso neto (kg)",
    Marca: "Marca",
    Modelo: "Modelo",
    Material: "Material",
    Voltagem: "Voltaje",
    "Grade de Produtos": "Cuadrícula de productos",
    "Criado em": "Creado el",
    "Atualizado em": "Actualizado el",
    "Un.": "Unidad",
    Valor: "Valor",
    Vencimento: "Vencimiento",
    Forma: "Forma",
    Entrada: "Entrada",
    Saida: "Salida",
    Saída: "Salida",
    Saldo: "Saldo",
    "Forma de Pagamento": "Forma de pago",
    "Data da venda": "Fecha de venta",
    Prazo: "Plazo",
    "Prazo de entrega": "Plazo de entrega",
    "Data de entrega": "Fecha de entrega",
    "Entrega confirmada": "Entrega confirmada",
    "Endereço igual ao do cliente": "Dirección igual a la del cliente",
    "Endereço de entrega": "Dirección de entrega",
    Itens: "Ítems",
    Total: "Total",
    Caixa: "Caja",
    Sim: "Sí",
    Não: "No",
    "Mapa de Clientes": "Mapa de clientes",
    "Clientes por Estado": "Clientes por estado",
    "Ranking por estado": "Ranking por estado",
    "Sem dados.": "Sin datos.",
    "Carregando…": "Cargando...",
    de: "de",
    "Tente outro nome, ID ou status.": "Pruebe con otro nombre, ID o estado.",
    "Nenhum registro encontrado": "No se encontraron registros",
    "Nenhum dado disponível.": "No hay datos disponibles.",
    "Mesclar linhas": "Combinar filas",
    "Remover favoritos": "Quitar favoritos",
    "Selecionar todos": "Seleccionar todos",
    Selecionar: "Seleccionar",
    Anterior: "Anterior",
    "Próximo": "Siguiente",
    Proximo: "Siguiente",
    "Subir ao topo": "Volver arriba",
    "Fechar opções": "Cerrar opciones",
    "Selecione...": "Seleccione...",
    "Digite para filtrar...": "Escriba para filtrar...",
    "Abrir calendário": "Abrir calendario",
    "Alternar visualização do calendário": "Cambiar vista del calendario",
    "Selecionar horário": "Seleccionar horario",
    "Cancelar seleção de horário": "Cancelar selección de horario",
    "Confirmar seleção de horário": "Confirmar selección de horario",
    Hora: "Hora",
    "Filtrar por": "Filtrar por",
    "Adicionar período": "Agregar período",
    "Ajustar intervalo temporal": "Ajustar intervalo temporal",
    "Ajustar Intervalo Temporal": "Ajustar Intervalo Temporal",
    "Período rápido": "Período rápido",
    "Selecionar período": "Seleccionar período",
    "Início selecionado": "Inicio seleccionado",
    "Escolha a data final no calendário.": "Elija la fecha final en el calendario.",
    "Use o calendário para escolher o início e o fim do período.": "Use el calendario para elegir el inicio y el fin del período.",
    "Esta Semana": "Esta semana",
    "Semana Passada": "Semana pasada",
    "Este Mês": "Este mes",
    "Ano Passado": "Año pasado",
    "Este Ano": "Este año",
    "3 Meses": "3 meses",
    "6 Meses": "6 meses",
    Personalizado: "Personalizado",
    Janeiro: "Enero",
    Fevereiro: "Febrero",
    Março: "Marzo",
    Abril: "Abril",
    Maio: "Mayo",
    Junho: "Junio",
    Julho: "Julio",
    Agosto: "Agosto",
    Setembro: "Septiembre",
    Outubro: "Octubre",
    Novembro: "Noviembre",
    Dezembro: "Diciembre",
    Jan: "Ene",
    Fev: "Feb",
    Mar: "Mar",
    Abr: "Abr",
    Mai: "May",
    Jun: "Jun",
    Jul: "Jul",
    Ago: "Ago",
    Set: "Sep",
    Out: "Oct",
    Nov: "Nov",
    Dez: "Dic",
    jan: "Ene",
    fev: "Feb",
    mar: "Mar",
    abr: "Abr",
    mai: "May",
    jun: "Jun",
    jul: "Jul",
    ago: "Ago",
    set: "Sep",
    out: "Oct",
    nov: "Nov",
    dez: "Dic",
    Dom: "Dom",
    Seg: "Lun",
    Ter: "Mar",
    Qua: "Mié",
    Qui: "Jue",
    Sex: "Vie",
    Sáb: "Sáb",
    Sab: "Sáb",
    "Importar dados": "Importar datos",
    "Importe registros a partir de uma planilha .xlsx ou .csv.": "Importe registros desde una hoja .xlsx o .csv.",
    "Use um arquivo .xlsx ou .csv.": "Use un archivo .xlsx o .csv.",
    "Não foi possível importar.": "No fue posible importar.",
    "Importação concluída.": "Importación concluida.",
    "registro(s) importado(s).": "registro(s) importado(s).",
    "Erro ao importar.": "Error al importar.",
    "Falha ao ler o arquivo.": "Error al leer el archivo.",
    "Clique ou arraste o arquivo .xlsx ou .csv": "Haga clic o arrastre el archivo .xlsx o .csv",
    "Formatos aceitos: XLSX, CSV · Tamanho máximo: 25 MB": "Formatos aceptados: XLSX, CSV · Tamaño máximo: 25 MB",
    "Baixe o modelo para usar como ponto de partida.": "Descargue el modelo para usarlo como punto de partida.",
    "Formatação do texto": "Formato del texto",
    Negrito: "Negrita",
    Itálico: "Cursiva",
    Sublinhado: "Subrayado",
    Tachado: "Tachado",
    "Cor do texto": "Color del texto",
    "Cor de realce": "Color de resaltado",
    "Limpar formatação": "Limpiar formato",
    "Inserir imagem": "Insertar imagen",
    "Inserir link": "Insertar enlace",
    "Inserir tabela": "Insertar tabla",
    "Alinhar à esquerda": "Alinear a la izquierda",
    Centralizar: "Centrar",
    "Alinhar à direita": "Alinear a la derecha",
    Justificar: "Justificar",
    "Diminuir recuo": "Disminuir sangría",
    "Aumentar recuo": "Aumentar sangría",
    "Lista numerada": "Lista numerada",
    "Lista com marcadores": "Lista con viñetas",
    "Caractere especial": "Carácter especial",
    Emoji: "Emoji",
    "Linha horizontal": "Línea horizontal",
    Fonte: "Fuente",
    "Tamanho da fonte": "Tamaño de fuente",
    "Formato do bloco": "Formato del bloque",
    Desfazer: "Deshacer",
    Refazer: "Rehacer",
    "Fonte do sistema": "Fuente del sistema",
    Parágrafo: "Párrafo",
    "Título 1": "Título 1",
    "Título 2": "Título 2",
    "Título 3": "Título 3",
    Inserir: "Insertar",
    Colunas: "Columnas",
    "Observação...": "Observación...",
    Lista: "Lista",
    Grade: "Cuadrícula",
    "Modo de visualização": "Modo de visualización",
    "Nenhuma notificação por aqui.": "No hay notificaciones por aquí.",
    "Buscar arquivo...": "Buscar archivo...",
    "Carregando anexos...": "Cargando adjuntos...",
    "Anexar arquivo": "Adjuntar archivo",
    Enviar: "Enviar",
    "Nenhuma noticia disponível.": "No hay noticias disponibles.",
    "Nenhuma notícia disponível.": "No hay noticias disponibles.",
    "Nenhuma nota encontrada.": "No se encontró ninguna nota.",
    "Validar CEP": "Validar código postal",
    "Selecionar cor personalizada": "Seleccionar color personalizado",
    "Cor personalizada": "Color personalizado",
    "Menu do usuário": "Menú de usuario",
    "Editar perfil": "Editar perfil",
    "Fechar tour": "Cerrar tour",
    "Reiniciar tour guiado": "Reiniciar tour guiado",
    "Alternar menu": "Alternar menú",
    "Seu nome": "Su nombre",
    "Digite a senha atual": "Ingrese la contraseña actual",
    "Digite a nova senha": "Ingrese la nueva contraseña",
    "Alterar foto de perfil": "Cambiar foto de perfil",
    "Selecione a empresa...": "Seleccione la empresa...",
    "Observações do lançamento…": "Observaciones del lanzamiento...",
    "Financeiro — Receitas x Despesas": "Finanzas — Ingresos vs Gastos",
    "Visao consolidada do período": "Vista consolidada del período",
    "Financeiro — Fluxo de caixa": "Finanzas — Flujo de caja",
    "Entradas, saidas e saldo do período": "Entradas, salidas y saldo del período",
    "Estoque — Movimentações (30 dias)": "Inventario — Movimientos (30 días)",
    "Entradas e saidas por dia": "Entradas y salidas por día",
    "Entradas e saídas por dia": "Entradas y salidas por día",
    "Estoque — Top produtos por saldo": "Inventario — Productos principales por saldo",
    "Compras — Pedidos por status": "Compras — Pedidos por estado",
    "Compras por dia": "Compras por día",
    "Evolucao do valor comprado por data": "Evolución del valor comprado por fecha",
    "Pedidos por status": "Pedidos por estado",
    "Compras por forma de pagamento": "Compras por forma de pago",
    "Top fornecedores por volume comprado": "Principales proveedores por volumen comprado",
    "Distribuição dos pedidos": "Distribución de pedidos",
    "Chamados por status": "Tickets por estado",
    "Por prioridade": "Por prioridad",
    "Por categoria": "Por categoría",
    "Faturamento por dia": "Facturación por día",
    "Evolucao das vendas registradas": "Evolución de ventas registradas",
    "Movimento do caixa PDV": "Movimiento de caja PDV",
    "Impacto diario das entradas e saidas": "Impacto diario de entradas y salidas",
    "Quantidade de vendas por dia": "Cantidad de ventas por día",
    "Volume diario das vendas avulsas": "Volumen diario de ventas sueltas",
    "Vendas por status": "Ventas por estado",
    "Receita por forma de pagamento": "Ingresos por forma de pago",
    "Top clientes por faturamento": "Principales clientes por facturación",
    "Receitas × Despesas": "Ingresos × Gastos",
    "Receitas por categoria": "Ingresos por categoría",
    "Despesas por categoria": "Gastos por categoría",
    "Proporção do período": "Proporción del período",
    "Movimentações (últimos 30 dias)": "Movimientos (últimos 30 días)",
    "Top produtos por saldo": "Productos principales por saldo",
    "Maior giro de estoque": "Mayor rotación de inventario",
    "Saídas / estoque médio": "Salidas / inventario promedio",
    "Evolução mensal": "Evolución mensual",
    "Receita, despesas, CMV e lucro líquido ao longo do tempo.": "Ingresos, gastos, CMV y utilidad neta a lo largo del tiempo.",
    "Composição da DRE": "Composición del estado de resultados",
    "Participação dos principais grupos de receitas e custos.": "Participación de los principales grupos de ingresos y costos.",
    Receitas: "Ingresos",
    Despesas: "Gastos",
    Receita: "Ingresos",
    "Lucro líquido": "Utilidad neta",
  },
  "zh-CN": {
    "Consumo de E-mails por Organização": "各组织邮件用量",
    "Acompanhe a cota mensal usada e disponível em cada organização.": "查看每个组织每月已用和可用的邮件额度。",
    Período: "周期",
    "Total geral": "总额度",
    Limite: "限额",
    "Total usado": "已用总数",
    "Total livre": "可用总数",
    "Última alteração": "最后更新",
    "Ativar API Resend para envio de e-mails": "启用 Resend API 发送邮件",
    "Quando desativada, nenhum e-mail automático será enviado.": "停用后，将不会发送任何自动邮件。",
    Ação: "操作",
    "Limite mensal de e-mails": "每月邮件限额",
    "Salvar limite mensal": "保存每月限额",
    "Nenhuma organização disponível para acompanhar.": "暂无可查看的组织。",
    "API Resend ativada com sucesso.": "Resend API 已成功启用。",
    "API Resend desativada com sucesso.": "Resend API 已成功停用。",
    "Erro ao atualizar a API Resend.": "无法更新 Resend API。",
    "Informe um limite mensal válido.": "请输入有效的每月限额。",
    "Erro ao salvar o limite de e-mails.": "无法保存邮件限额。",
    "Limite de e-mails atualizado com sucesso.": "邮件限额已成功更新。",
    Enviados: "已发送",
    Reclamados: "投诉",
    Atrasados: "延迟",
    "Entregabilidade de E-mails": "邮件送达率",
    "Envios e eventos do Resend por dia, nos últimos 30 dias (conta inteira).": "过去30天内 Resend 每日发送量及事件（整个账户）。",
    "Limite Diário de Envio": "每日发送限额",
    "Limite diário": "每日限额",
    "Enviados hoje": "今日已发送",
    "Restante hoje": "今日剩余",
    "Limite diário de e-mails": "每日邮件限额",
    "Salvar limite diário": "保存每日限额",
    "Limite da conta Resend, compartilhado por todas as organizações. Ao ser atingido, novos envios ficam em espera até o dia seguinte para evitar erros do Resend.": "Resend 账户的限额，由所有组织共享。达到限额后，新邮件将等到第二天发送，以避免 Resend 报错。",
    "Informe um limite diário válido.": "请输入有效的每日限额。",
    "Erro ao salvar o limite diário de e-mails.": "保存每日邮件限额时出错。",
    "Limite diário de e-mails atualizado com sucesso.": "每日邮件限额更新成功。",
    "Configure o segredo do webhook Resend acima para que os eventos de entrega, abertura e clique comecem a aparecer aqui.": "请在上方配置 Resend Webhook 密钥，送达、打开和点击等事件才会显示在这里。",
    "Erro ao atualizar o envio de e-mails da organização.": "无法更新该组织的邮件发送设置。",
    "Envio de e-mails ativado para a organização.": "已为该组织启用邮件发送。",
    "Envio de e-mails desativado para a organização.": "已为该组织停用邮件发送。",
    "8+ Caracteres": "8+ 个字符",
    "Letra Maiúscula": "大写字母",
    "Especial (!@#)": "特殊符号 (!@#)",
    "Não foi possível confirmar os dados gerais salvos no banco.": "无法确认数据库中保存的常规数据。",
    "Erro ao salvar a chave.": "无法保存 API 密钥。",
    "Aparência e funcionalidades salvas com sucesso.": "外观和功能设置已成功保存。",
    "Erro ao salvar aparência e funcionalidades.": "无法保存外观和功能设置。",
    "Cor do plano de fundo da sidebar": "侧边栏背景颜色",
    "Opacidade do plano de fundo da sidebar": "侧边栏背景不透明度",
    "Gradiente do plano de fundo": "背景渐变",
    "Gradiente botões": "按钮渐变",
    "Gradiente plano de fundo": "背景渐变",
    "Inverter gradiente": "反转渐变",
    "Gradiente 1 - superior esquerdo": "渐变 1 - 左上角",
    "Gradiente 2 - inferior direito": "渐变 2 - 右下角",
    "Tamanho do gradiente 1": "渐变 1 大小",
    "Tamanho do gradiente 2": "渐变 2 大小",
    "Movimento horizontal do gradiente 1": "渐变 1 水平移动",
    "Movimento vertical do gradiente 1": "渐变 1 垂直移动",
    "Movimento horizontal do gradiente 2": "渐变 2 水平移动",
    "Movimento vertical do gradiente 2": "渐变 2 垂直移动",
    "Resetar posições": "重置位置",
    "Configuração dos gradientes inválida.": "渐变设置无效。",
    "Cor do tema": "主题颜色",
    Roxo: "紫色",
    "Cinza claro": "浅灰色",
    "Cinza gelo": "冰灰色",
    "Cinza médio": "中灰色",
    "Preto suave": "柔黑色",
    "Bege claro": "浅米色",
    Areia: "沙色",
    Branco: "白色",
    "Azul claro": "浅蓝色",
    "Verde claro": "浅绿色",
    "Violeta claro": "浅紫色",
    "Laranja claro": "浅橙色",
    Grafite: "石墨色",
    "Cinza escuro": "深灰色",
    "Azul noite": "午夜蓝",
    "Configuração da sidebar inválida.": "侧边栏配置无效。",
    "Configurações de IA salvas com sucesso.": "AI 设置已成功保存。",
    "As configurações de IA foram salvas, mas moedas e tarifas não foram alteradas porque a cobrança não pôde ser carregada.": "AI 设置已保存，但由于无法加载计费配置，AI 币和费率未更改。",
    "Erro ao salvar as configurações de IA.": "无法保存 AI 设置。",
    "Configurações de E-mail salvas com sucesso.": "邮件设置已成功保存。",
    "Erro ao salvar as configurações de E-mail.": "无法保存邮件设置。",
    "Configuração Asaas salva com sucesso.": "Asaas 设置已成功保存。",
    "Erro ao salvar a configuração Asaas.": "无法保存 Asaas 设置。",
    "Configuração de entrega": "发送设置",
    "Configurações de E-mail": "邮件设置",
    "Configurar email": "配置邮件",
    "Modelos de E-mail": "邮件模板",
    "Boas-vindas": "欢迎邮件",
    "Recuperação de senha": "密码恢复",
    "Pedidos de insumos dos clientes": "客户物料订单",
    "Pedidos de suporte dos clientes": "客户支持请求",
    "Vencimento de insumos": "物料到期",
    "Avisar quando um cliente enviar um novo pedido de insumos.": "客户提交新的物料订单时通知。",
    "Avisar quando um cliente enviar um novo pedido de suporte.": "客户提交新的支持请求时通知。",
    "Avisar quando um insumo estiver próximo do vencimento.": "物料临近到期时通知。",
    Favoritar: "添加到收藏",
    "Remover favorito": "从收藏中移除",
    "Erro ao atualizar favorito.": "无法更新收藏状态。",
    "Visualize e edite os modelos usados nas notificações automáticas.": "查看和编辑自动通知所使用的邮件模板。",
    "Nome do Email": "邮件名称",
    "Tipo de email": "邮件类型",
    "Nenhum modelo de e-mail encontrado": "未找到邮件模板",
    "Ajuste a busca para localizar um modelo.": "调整搜索条件以查找模板。",
    "Buscar modelos de e-mail...": "搜索邮件模板...",
    "Editar modelo de e-mail": "编辑邮件模板",
    "Personalize o conteúdo enviado aos destinatários.": "自定义发送给收件人的内容。",
    "Conteúdo do e-mail": "邮件内容",
    "Digite o conteúdo do e-mail...": "输入邮件内容...",
    "Preencha o conteúdo do e-mail.": "请输入邮件内容。",
    "Erro ao carregar os modelos de e-mail.": "无法加载邮件模板。",
    "Erro ao salvar o modelo de e-mail.": "无法保存邮件模板。",
    "Modelo de e-mail atualizado com sucesso.": "邮件模板更新成功。",
    "Marcadores obrigatórios": "必需占位符",
    "Esses marcadores recebem os dados do evento e não podem ser removidos.": "这些占位符用于接收事件数据，不能删除。",
    "Mantenha os marcadores obrigatórios no corpo do e-mail:": "请保留邮件正文中的必需占位符：",
    "Defina o remetente, as respostas, o modo de teste e o endereço público usado nos links.": "设置发件人、回复地址、测试模式以及链接中使用的公开地址。",
    "Remetente Resend": "Resend 发件人",
    "E-mail para respostas": "回复邮箱",
    "Destinatário de teste": "测试收件人",
    "URL pública da plataforma": "平台公开网址",
    "Ex.: Minha Empresa <notificacoes@seudominio.com>": "例如：我的公司 <notifications@yourdomain.com>",
    "Ex.: suporte@seudominio.com": "例如：support@yourdomain.com",
    "Vazio em produção": "生产环境留空",
    "Ex.: https://app.seudominio.com": "例如：https://app.yourdomain.com",
    "Use o remetente com um domínio verificado no Resend. Deixe o destinatário de teste vazio em produção para enviar aos destinatários reais.": "请使用 Resend 中已验证域名的发件人。生产环境请将测试收件人留空，以发送给真实收件人。",
    "Salvar configuração de entrega": "保存发送设置",
    "Configuração de entrega salva com sucesso.": "发送设置已成功保存。",
    "Erro ao salvar a configuração de entrega.": "无法保存发送设置。",
    "Informe um remetente válido.": "请输入有效的发件人。",
    "Informe um e-mail de resposta válido.": "请输入有效的回复邮箱。",
    "Informe um destinatário de teste válido.": "请输入有效的测试收件人。",
    "Informe uma URL pública válida.": "请输入有效的公开网址。",
    "URL do webhook Resend": "Resend Webhook URL",
    "Copiar URL do webhook": "复制 Webhook URL",
    "Segredo do webhook Resend": "Resend Webhook 密钥",
    "Segredo configurado": "密钥已配置",
    "Cole o segredo whsec_ fornecido pelo Resend": "粘贴 Resend 提供的 whsec_ 密钥",
    "No Resend, adicione a URL acima ao webhook, selecione os eventos de e-mail e depois salve aqui o segredo de assinatura whsec_.": "在 Resend 中将上述 URL 添加到 Webhook，选择邮件事件，然后在此保存 whsec_ 签名密钥。",
    "Eventos do webhook por organização": "各组织的 Webhook 事件",
    "Totais do período para e-mails clicados, entregues, falhos e rejeitados.": "本周期已点击、已送达、失败和被拒邮件的总数。",
    Clicados: "已点击",
    Entregues: "已送达",
    Falhos: "失败",
    Rejeitados: "被拒",
    "URL do webhook copiada com sucesso.": "Webhook URL 已成功复制。",
    "Não foi possível copiar a URL do webhook.": "无法复制 Webhook URL。",
    "Informe um segredo de webhook Resend válido.": "请输入有效的 Resend Webhook 密钥。",
    "Balanço Inicial": "初始库存盘点",
    "Produtos selecionados para contagem inicial": "已选择用于初始盘点的产品",
    "Iniciar contagem": "开始盘点",
    "Agendas neste dia": "当天日程",
    "Dados do inventário": "盘点详情",
    "Data do inventário": "盘点日期",
    "Total de itens": "项目总数",
    "Divergência total": "总差异",
    Contagem: "盘点",
    "Itens do inventário": "盘点项目",
    "Itens do balanço": "盘点明细",
    "Quantidade no sistema": "系统数量",
    "Quantidade no balanço": "盘点数量",
    "Nenhum item encontrado": "未找到项目",
    Sistema: "系统",
    Contada: "实盘数量",
    Diferença: "差异",
    "Finalizado em": "完成时间",
    Complementos: "补充信息",
    "Visão Geral": "概览",
    Cadastros: "基础资料",
    Empresa: "公司",
    Empresas: "公司",
    Banco: "银行",
    Clientes: "客户",
    Cliente: "客户",
    Fornecedor: "供应商",
    Fornecedores: "供应商",
    Transportadora: "承运商",
    Colaborador: "员工",
    Colaboradores: "员工",
    Produto: "产品",
    Produtos: "产品",
    Serviço: "服务",
    Serviços: "服务",
    "Unidade de Medida": "计量单位",
    Categoria: "类别",
    Categorias: "类别",
    Armazenamento: "仓储",
    Tamanho: "尺码",
    Cor: "颜色",
    "Plano de Contas": "会计科目表",
    "Maquininhas e Taxas": "刷卡机和费率",
    Erro: "错误",
    Serial: "序列号",
    "Perfil de Usuário": "用户角色",
    Login: "登录",
    "Pedidos de Insumo": "物料订单",
    "Pedidos de Suporte": "支持请求",
    Vendas: "销售",
    Venda: "销售",
    Orçamentos: "报价",
    Orçamento: "报价",
    Entregas: "交付",
    Entrega: "交付",
    "Caixa PDV": "POS 收银",
    Compras: "采购",
    Compra: "采购",
    Pedidos: "订单",
    Pedido: "订单",
    Estoque: "库存",
    "Saldo Atual": "当前余额",
    Movimentações: "库存流水",
    Movimentação: "库存流水",
    Inventário: "盘点",
    Financeiro: "财务",
    "Contas a Receber": "应收账款",
    "Vendas Parceladas": "分期销售",
    "Contas a Pagar": "应付账款",
    "Conciliação de Cartões": "银行卡对账",
    "Fluxo de Caixa": "现金流",
    DRE: "损益表",
    Suporte: "支持",
    Kanban: "看板",
    Calendário: "日历",
    "Planeje e acompanhe as tarefas de suporte por data.": "按日期规划和跟踪支持任务。",
    "Nova tarefa": "新建任务",
    Chamados: "工单",
    Chamado: "工单",
    Relatórios: "报表",
    Relatório: "报表",
    Idioma: "语言",
    Notificações: "通知",
    "Bloco de Notas": "便签",
    "Minha conta": "我的账户",
    Ajuda: "帮助",
    "Log de acesso": "访问日志",
    Configurações: "设置",
    Sair: "退出",
    Usuário: "用户",
    "Modo Dark": "深色模式",
    Status: "状态",
    Disponível: "在线",
    Ausente: "离开",
    "Off-line": "离线",
    "Acesso restrito ao dono da plataforma": "仅平台所有者可访问",
    "Pesquisar menu": "搜索菜单",
    "Trocar de empresa": "切换公司",
    "Pesquisar Filial": "搜索分支",
    "Todas as empresas": "所有公司",
    Organizações: "组织",
    "Todas as organizações": "所有组织",
    "Carregando organizações...": "正在加载组织...",
    "Nenhuma organização encontrada para essa busca.": "没有找到匹配的组织。",
    "Não foi possível carregar organizações.": "无法加载组织。",
    "Não foi possível trocar a organização.": "无法切换组织。",
    "Não foi possível trocar a empresa.": "无法切换公司。",
    "Empresas da organização": "组织公司",
    "Selecione uma organização para listar as empresas.": "请选择组织以列出公司。",
    "Carregando empresas...": "正在加载公司...",
    "Nenhuma empresa encontrada para essa busca.": "没有找到匹配的公司。",
    Atual: "当前",
    "Trocando...": "正在切换...",
    "Erro ao carregar o perfil.": "加载个人资料时出错。",
    "Não foi possível salvar o perfil.": "无法保存个人资料。",
    "Erro ao salvar o perfil.": "保存个人资料时出错。",
    "Perfil salvo com sucesso.": "个人资料保存成功。",
    "Não foi possível remover a foto.": "无法删除照片。",
    "Foto removida com sucesso.": "照片删除成功。",
    "Erro ao remover a foto.": "删除照片时出错。",
    "Informe a senha atual e a nova senha.": "请输入当前密码和新密码。",
    "A nova senha deve ter ao menos 6 caracteres.": "新密码必须至少包含 6 个字符。",
    "Não foi possível alterar a senha.": "无法更改密码。",
    "Senha alterada com sucesso.": "密码更改成功。",
    "Erro ao alterar a senha.": "更改密码时出错。",
    "Selecione uma imagem PNG ou JPG.": "请选择 PNG 或 JPG 图片。",
    "Imagem muito grande. O limite é 8MB.": "图片过大，限制为 8 MB。",
    "Não foi possível salvar a foto.": "无法保存照片。",
    "Foto de perfil salva com sucesso.": "个人资料照片保存成功。",
    "Erro ao processar a foto.": "处理照片时出错。",
    "Todos os períodos": "所有期间",
    "Período selecionado!": "已选择期间！",
    "Assistente de IA": "AI 助手",
    "Um ótimo domingo": "祝您周日愉快",
    Segundou: "周一开始",
    Sextou: "周五到了",
    "Bom dia": "早上好",
    "Boa tarde": "下午好",
    "Boa noite": "晚上好",
    hoje: "今天",
    "até": "至",
    Novo: "新建",
    Nova: "新建",
    "Novo Produto": "新产品",
    "Nova Empresa": "新公司",
    "Nova Categoria": "新类别",
    "Adicionar categoria": "添加类别",
    Cadastrar: "注册",
    Salvar: "保存",
    Cancelar: "取消",
    Editar: "编辑",
    Excluir: "删除",
    Duplicar: "复制",
    Exportar: "导出",
    Importar: "导入",
    Imprimir: "打印",
    Visualizar: "查看",
    Tickets: "工单",
    "Visualizar Grade": "查看网格",
    Atualizar: "刷新",
    Limpar: "清除",
    Filtrar: "筛选",
    Filtros: "筛选器",
    Buscar: "搜索",
    Pesquisar: "搜索",
    Fechar: "关闭",
    Confirmar: "确认",
    Voltar: "返回",
    Continuar: "继续",
    Avançar: "下一步",
    Dados: "数据",
    Observação: "备注",
    Observações: "备注",
    "Observações...": "备注...",
    Descrição: "描述",
    Nome: "名称",
    Ativo: "启用",
    Ativa: "启用",
    Inativo: "停用",
    Inativa: "停用",
    Obrigatório: "必填",
    "Campos obrigatórios": "必填字段",
    Email: "邮箱",
    "E-mail": "邮箱",
    Senha: "密码",
    Perfil: "资料",
    "Empresa Principal": "主公司",
    "Empresas de acesso": "可访问公司",
    Telefone: "电话",
    Celular: "手机",
    Endereço: "地址",
    Número: "编号",
    Cidade: "城市",
    Estado: "州/省",
    País: "国家",
    Código: "代码",
    "Código interno": "内部代码",
    "Código de barras": "条形码",
    SKU: "SKU",
    Tags: "标签",
    "Estoque Mín.": "最低库存",
    "Estoque Min.": "最低库存",
    Preço: "价格",
    Custo: "成本",
    Unidade: "单位",
    Imagem: "图片",
    Cargo: "职位",
    Departamento: "部门",
    Funcionario: "员工",
    Funcionário: "员工",
    Estagiario: "实习生",
    Estagiário: "实习生",
    Terceirizado: "外包",
    Autonomo: "自雇",
    Autônomo: "自雇",
    Temporario: "临时",
    Temporário: "临时",
    "Tipo do colaborador": "员工类型",
    "Tipo de colaborador": "员工类型",
    "Pessoa Física": "个人",
    "Pessoa Juridica": "法人",
    "Pessoa Jurídica": "法人",
    Avulso: "单次",
    "Com Grade": "有网格",
    "Sem Grade": "无网格",
    Próprio: "自有",
    Proprio: "自有",
    Expresso: "快速",
    Econômico: "经济",
    Economico: "经济",
    Agregado: "聚合",
    "Cor da Tag": "标签颜色",
    "Remover tag": "移除标签",
    "Digite e pressione Enter...": "输入并按 Enter...",
    "Valor bruto": "毛额",
    "Valor total": "总金额",
    "Valor recebido": "已收金额",
    "Valor da parcela": "分期金额",
    "Valor por parcela": "每期金额",
    "Valor Parcelado": "分期金额",
    "Total de parcelas": "总期数",
    "Total com juros": "含利息总额",
    "Juros": "利息",
    Desconto: "折扣",
    Troco: "找零",
    "Falta receber": "待收金额",
    "Primeiro vencimento": "首次到期日",
    "Status atual": "当前状态",
    Parcela: "分期",
    "Tipo do cartão": "卡类型",
    "Tipo de ativação": "激活类型",
    "Prazo de ativação": "激活期限",
    Chave: "密钥",
    Causa: "原因",
    Solução: "解决方案",
    Solucao: "解决方案",
    Sabor: "口味",
    Volume: "容量",
    "Preço Adicional": "附加价格",
    "Preço de Venda": "销售价格",
    "Nome do erro": "错误名称",
    "Descrição do erro": "错误描述",
    "Nome do caixa": "收银名称",
    "Saldo de abertura": "期初余额",
    "Data e hora do fechamento": "关闭日期和时间",
    "Usuário responsável": "负责用户",
    "Fundo de caixa para manter": "保留备用金",
    "Selecione a empresa primeiro": "请先选择公司",
    "Sem prazo definido": "未设置期限",
    "Nao definida": "未定义",
    "Não definida": "未定义",
    Linhas: "行数",
    "Produto salvo com sucesso.": "产品保存成功。",
    "Erro interno do servidor.": "无法完成操作。请检查输入的数据后重试。",
    "Um campo do cadastro não está disponível no banco de dados.": "数据库中没有此记录的某个字段。",
    "Código já existe.": "代码已存在。",
    "O código já existe.": "该代码已存在。",
    "SKU já cadastrado.": "SKU 已注册。",
    "Código SKU já cadastrado.": "SKU 代码已注册。",
    "Nenhum registro encontrado.": "未找到记录。",
    "Nenhum item encontrado.": "未找到项目。",
    "Carregando...": "正在加载...",
    "Processando...": "处理中...",
    Bancos: "银行",
    "Cadastro das contas bancárias vinculadas às empresas.": "登记与公司关联的银行账户。",
    "Nome do banco": "银行名称",
    "Nome do Banco": "银行名称",
    "Código do banco": "银行代码",
    "Banco da venda": "销售银行",
    "Selecione o banco": "选择银行",
    "Carregando bancos...": "正在加载银行...",
    "Sem bancos nesta empresa": "该公司尚未登记银行",
    "Não foi possível carregar os bancos.": "无法加载银行。",
    "Banco não encontrado para a empresa selecionada.": "未找到所选公司的银行。",
    Agência: "分行",
    "Agência / Conta": "分行 / 账户",
    "Tipo da conta": "账户类型",
    "Tipo da Conta": "账户类型",
    Titular: "账户持有人",
    "Dígito da agência": "分行校验位",
    Conta: "账户",
    "Dígito da conta": "账户校验位",
    "Documento do titular": "持有人证件",
    "Chave PIX": "PIX 密钥",
    "Tipo da chave PIX": "PIX 密钥类型",
    "Banco principal": "主银行",
    "Dados bancários": "银行资料",
    Identificação: "标识",
    "Titular e PIX": "持有人和 PIX",
    "Conta Corrente": "支票账户",
    "Conta Poupanca": "储蓄账户",
    "Conta Poupança": "储蓄账户",
    Pagamentos: "付款",
    Salario: "工资",
    Salário: "工资",
    Investimentos: "投资",
    Corrente: "支票",
    Poupanca: "储蓄",
    Poupança: "储蓄",
    Pagamento: "付款",
    Investimento: "投资",
    Outra: "其他",
    Principal: "主",
    "Sem nome": "未命名",
    "Cód.": "代码",
    "Buscar por descrição…": "按描述搜索…",
    "Buscar por nome do banco...": "按银行名称搜索...",
    "Buscar por nome, CNPJ, cidade...": "按名称、CNPJ、城市搜索...",
    "Buscar por nome, equipamento...": "按名称、设备搜索...",
    "Buscar por nome, SKU, categoria...": "按名称、SKU、类别搜索...",
    "Buscar por número, origem, destino...": "按编号、来源和目的地搜索...",
    "Buscar por nome, CPF, cargo...": "按名称、CPF、职位搜索...",
    "Buscar por nome, CPF, cargo…": "按名称、CPF、职位搜索...",
    "Buscar por nome, e-mail...": "按名称、邮箱搜索...",
    "Nenhuma opção encontrada": "未找到选项",
    Baixa: "低",
    Média: "中",
    Alta: "高",
    Urgente: "紧急",
    Aberto: "打开",
    Abertos: "打开",
    Iniciado: "已开始",
    Tarefas: "任务",
    "Em andamento": "进行中",
    Aguardando: "等待中",
    Concluído: "已完成",
    Concluido: "已完成",
    Concluída: "已完成",
    Concluida: "已完成",
    Fechado: "已关闭",
    "Nenhum chamado nesta etapa.": "此阶段没有工单。",
    "Nenhum chamado encontrado": "未找到工单",
    "Novo chamado": "新工单",
    "Editar chamado": "编辑工单",
    Prioridade: "优先级",
    Responsável: "负责人",
    "Responsavel": "负责人",
    Solicitante: "请求人",
    Solicitação: "请求",
    Solicitacao: "请求",
    Finalização: "完成",
    "Finalizacao": "完成",
    Início: "开始",
    Inicio: "开始",
    Título: "标题",
    Titulo: "标题",
    "Carregando chamados...": "正在加载工单...",
    "Abrir menu da tarefa": "打开任务菜单",
    "Editar tarefa": "编辑任务",
    "Excluir tarefa": "删除任务",
    "Adicionar tarefa": "添加任务",
    "Chamado sem titulo": "无标题工单",
    "Chamado sem título": "无标题工单",
    "Tarefa do calendário": "日历任务",
    "Pedido do cliente": "客户请求",
    "Chamado avulso": "独立工单",
    "Visualizar chamado": "查看工单",
    "Mover para": "移动到",
    "Voltar para": "返回到",
    "Suporte — Visão Geral": "支持 — 概览",
    "Suporte — Dashboard": "支持 — 仪表板",
    "Login de suporte": "支持登录",
    Todos: "全部",
    "Visualizar tarefa": "查看任务",
    "Dados da tarefa": "任务详情",
    "Tarefa sem título": "无标题任务",
    "Sem descrição.": "无描述。",
    "Criado por": "创建者",
    Fim: "结束",
   "Tempo médio de atendimento": "平均处理时长",
    "Resposta média do chamado": "工单平均响应",
    "Chamados sem início": "未开始工单",
    "Mês de maior fluxo": "流量最高月份",
    "Equipe de suporte": "支持团队",
    "Cards por usuário com volume, tempos e itens ativos.": "按用户展示数量、时长和活跃项目的卡片。",
    Ativos: "活跃",
    Resposta: "响应",
    Atendimento: "处理",
    "Sem dados suficientes.": "数据不足。",
    "Fluxo mensal de atendimento": "月度支持流量",
    "Distribuição de chamados abertos nos últimos 12 meses.": "过去 12 个月已创建工单的分布。",
    "SLA de resposta": "响应 SLA",
    "Média frente à meta de 8h.": "与 8 小时目标相比的平均值。",
    "Tickets Abertos": "未关闭工单",
    "Resolvidos Hoje": "今日已解决",
    "SLA Médio": "平均 SLA",
    "Tempo Médio de Resposta": "平均响应时间",
    "Satisfação do Cliente": "客户满意度",
    "Pesquisa de Satisfação": "满意度调查",
    "Detalhes da venda": "销售详情",
    Onboarding: "新手引导",
    "Defina o idioma da plataforma": "选择平台语言",
    "vs semana anterior": "较上周",
    "vs ontem": "较昨天",
    "Em Andamento": "处理中",
    "Crítica": "紧急",
    "Evolução de Tickets": "工单趋势",
    "Últimos 7 dias": "最近 7 天",
    "Últimos 14 dias": "最近 14 天",
    "Últimos 30 dias": "最近 30 天",
    "Distribuição por Prioridade": "按优先级分布",
    "tickets": "工单",
    "Status do Atendimento": "服务状态",
    "Novos": "新建",
    "Aguardando Cliente": "等待客户",
    "Em Atendimento": "处理中",
    "Escalados": "已升级",
    "Finalizados": "已完成",
    "Tickets Recentes": "最近工单",
    "Ver todos": "查看全部",
    "Assunto": "主题",
    "Canal": "渠道",
    "Última Atualização": "最后更新",
    "Ver ranking": "查看排名",
    "tickets resolvidos": "已解决工单",
    "Resposta média": "平均响应",
    "Radar do suporte": "支持雷达图",
    "Comparativo normalizado dos principais responsáveis.": "主要负责人的标准化对比。",
    "Atendimentos por suporte": "按支持人员统计处理量",
    "Atendimentos": "处理量",
    "Total de atendimentos por mês": "每月处理总量",
    "Atendimentos de janeiro a dezembro.": "一月至十二月的处理量。",
    "Chamados concluídos, ativos e tarefas por responsável.": "按负责人统计已完成工单、活跃工单和任务。",
    "Resposta média por suporte": "按支持人员统计平均响应",
    "Horas entre chegada do chamado e início do atendimento.": "从工单到达至开始处理之间的小时数。",
    "Dashboard de Suporte": "支持仪表板",
    "Panorama do Kanban, dos chamados e das tarefas do calendário.": "看板、工单和日历任务概览。",
    "Erro ao carregar a visão geral.": "无法加载概览。",
    "Itens do Kanban por etapa": "按阶段统计的看板项目",
    "Chamados e tarefas no fluxo atual.": "当前流程中的工单和任务。",
    "Carga ativa por responsável": "按负责人统计的当前工作量",
    "Itens ainda não concluídos.": "尚未完成的项目。",
    "Tarefas do calendário por prioridade": "按优先级统计的日历任务",
    "Evolução dos chamados": "工单趋势",
    "Aberturas e conclusões nos últimos 6 meses.": "过去 6 个月创建和完成的工单。",
    "Agenda dos próximos 7 dias": "未来 7 天日程",
    "Tarefas não concluídas por data programada.": "按计划日期统计未完成任务。",
    "Movimentações do Kanban": "看板流转记录",
    "Atividade registrada nos últimos 14 dias.": "过去 14 天记录的活动。",
    "Atividade registrada nos últimos 15 dias.": "过去 15 天记录的活动。",
    "Sem responsável": "未分配负责人",
    Concluídos: "已完成",
    "Registrar movimentação do Kanban": "记录看板流转",
    "Confirmar movimentação": "确认流转",
    "Etapa de destino": "目标阶段",
    "Informe o que foi feito ou o motivo da movimentação...": "请说明已完成的工作或流转原因...",
    "Informe o que foi feito ou o motivo da movimentação.": "请说明已完成的工作或流转原因。",
    "Não foi possível salvar um dos anexos da movimentação.": "无法保存其中一个流转附件。",
    "Movimentação inválida para a etapa atual do Kanban.": "当前看板阶段不允许此流转。",
    "Carregando itens...": "正在加载项目...",
    "Nenhum item nesta etapa.": "此阶段没有项目。",
    "Linha do tempo": "时间线",
    "Histórico do atendimento": "服务历史",
    "Chamado aberto": "工单已创建",
    "Tarefa criada": "任务已创建",
    "Nenhum histórico disponível.": "暂无历史记录。",
    "Etapa não utilizada.": "未使用此阶段。",
    "Mostrar todos os históricos": "显示全部历史",
    "Mostrar somente o concluído selecionado": "仅显示所选已完成项目",
    "Clique em um item concluído para ver a linha do tempo.": "点击已完成项目以查看时间线。",
    "Excluir chamado": "删除工单",
    "Registrar avanço do Kanban": "记录看板进展",
    "Descreva o que foi feito ou o motivo da mudança de etapa.": "说明已完成的工作或阶段变更原因。",
    "Confirmar avanço": "确认推进", Item: "项目", "Próxima etapa": "下一阶段", "Registro da etapa": "阶段记录",
    "Informe o que foi feito ou o motivo do avanço...": "填写已完成的工作或推进原因……",
    "Informe o que foi feito ou o motivo do avanço.": "请填写已完成的工作或推进原因。",
    "Não foi possível salvar um dos anexos do avanço.": "无法保存其中一个进展附件。",
    "Movimentação inválida. Avance o item seguindo a sequência do Kanban.": "移动无效。请按看板顺序推进项目。",
    "Chamados não podem ser excluídos pelo Kanban.": "不能从看板中删除工单。", "anexo(s)": "附件",
    "Movimente o chamado pelo Kanban e registre o que foi feito ou o motivo do avanço.": "请通过看板移动工单，并记录已完成的工作或推进原因。",
    "Item movido com sucesso.": "项目移动成功。",
    "Não foi possível mover o item.": "无法移动该项目。",
    "Tarefa excluída com sucesso.": "任务删除成功。",
    "Chamado excluído com sucesso.": "工单删除成功。",
    "Não foi possível excluir o chamado.": "无法删除工单。",
    "Excluir a tarefa": "删除任务",
    "Quadro visual de tarefas, pedidos e chamados com prioridade, data de início e pessoa responsável.": "按优先级、开始日期和负责人展示任务、请求和工单的可视化看板。",
    "Item ou etapa do Kanban inválida.": "看板项目或阶段无效。",
    "Você não tem permissão para movimentar este chamado.": "您无权移动此工单。",
    "Você não tem permissão para movimentar esta tarefa.": "您无权移动此任务。",
    "Armazenamentos": "仓储",
    "Cadastro dos locais/depósitos onde os produtos são armazenados.": "登记产品存放的位置/仓库。",
    "Importar Armazenamentos": "导入仓储",
    "Categorias de Estoque": "库存类别",
    "Organize os produtos por categoria.": "按类别组织产品。",
    "Importar Categorias de Estoque": "导入库存类别",
    "Unidades de Medida": "计量单位",
    "Cadastro das unidades de medida usadas nos produtos (UN, KG, CX…).": "登记产品使用的计量单位（UN、KG、箱等）。",
    "Importar Unidades de Medida": "导入计量单位",
    Cores: "颜色",
    "Cadastro de cores usadas nos produtos.": "登记产品使用的颜色。",
    Erros: "错误",
    "Cadastro de erros técnicos: causa, solução e documentação.": "登记技术错误：原因、解决方案和文档。",
    Tamanhos: "尺码",
    "Cadastro de tamanhos (calçado, roupa, etc).": "登记尺码（鞋、服装等）。",
    "Cadastro de chaves de ativação por produto.": "按产品登记激活密钥。",
    Classificação: "分类",
    Tag: "标签",
    Fantasia: "商号",
    Tipo: "类型",
    "Natureza Juridica": "法律性质",
    "Razão Social": "法定名称",
    "Razao Social": "法定名称",
    "Nome / Razão Social": "名称 / 法定名称",
    "Tipo de Pessoa": "人员类型",
    "Data de Nascimento": "出生日期",
    "Inscrição Estadual": "州登记",
    "Inscrição Municipal": "市政登记",
    "Inscrição SUFRAMA": "SUFRAMA 登记",
    "Regime Tributário": "税制",
    "Insc. Municipal": "市政登记",
    "Insc. Estadual": "州登记",
    "Nome Fantasia": "商号",
    "Tel. Fixo": "固定电话",
    "Telefone Fixo": "固定电话",
    "CNPJ/CPF": "CNPJ/CPF",
    "CNPJ / CPF": "CNPJ / CPF",
    "Atende por WhatsApp": "支持 WhatsApp",
    CEP: "邮编",
    Complemento: "补充地址",
    Bairro: "街区",
    Contato: "联系人",
    Site: "网站",
    "Nome do Responsável": "负责人姓名",
    "CPF do Responsável": "负责人 CPF",
    "Cargo do Responsável": "负责人职位",
    "Telefone do Responsável": "负责人电话",
    "E-mail do Responsável": "负责人邮箱",
    "RG / Inscrição Estadual": "身份证 / 州登记",
    "Prazo médio (dias)": "平均期限（天）",
    "Prazo médio de entrega (dias)": "平均交付期（天）",
    "Nome do Produto": "产品名称",
    "Código SKU": "SKU 代码",
    "Código de Barras": "条形码",
    "Código Externo": "外部代码",
    "Estoque Mínimo": "最低库存",
    "Estoque Máximo": "最高库存",
    "Custo Médio": "平均成本",
    "Custo Médio (R$)": "平均成本 (R$)",
    "Preço Venda": "销售价格",
    "Preço de Venda (R$)": "销售价格 (R$)",
    "Descrição Resumida": "简短描述",
    "Descrição Completa": "完整描述",
    "Altura (cm)": "高度 (cm)",
    "Largura (cm)": "宽度 (cm)",
    "Comprimento (cm)": "长度 (cm)",
    "Peso Bruto (kg)": "毛重 (kg)",
    "Peso Líquido (kg)": "净重 (kg)",
    Marca: "品牌",
    Modelo: "型号",
    Material: "材料",
    Voltagem: "电压",
    "Grade de Produtos": "产品网格",
    "Criado em": "创建于",
    "Atualizado em": "更新于",
    "Un.": "单位",
    Valor: "金额",
    Vencimento: "到期日",
    Forma: "方式",
    Entrada: "收入",
    Saida: "支出",
    Saída: "支出",
    Saldo: "余额",
    "Forma de Pagamento": "付款方式",
    "Data da venda": "销售日期",
    Prazo: "期限",
    "Prazo de entrega": "交付期限",
    "Data de entrega": "交付日期",
    "Entrega confirmada": "已确认交付",
    "Endereço igual ao do cliente": "地址与客户相同",
    "Endereço de entrega": "交付地址",
    Itens: "项目",
    Total: "总计",
    Caixa: "收银",
    Sim: "是",
    Não: "否",
    "Mapa de Clientes": "客户地图",
    "Clientes por Estado": "按州划分的客户",
    "Ranking por estado": "按州排名",
    "Sem dados.": "无数据。",
    "Carregando…": "正在加载...",
    de: "共",
    "Tente outro nome, ID ou status.": "请尝试其他名称、ID 或状态。",
    "Nenhum registro encontrado": "未找到记录",
    "Nenhum dado disponível.": "暂无可用数据。",
    "Mesclar linhas": "合并行",
    "Remover favoritos": "移除收藏",
    "Selecionar todos": "全选",
    Selecionar: "选择",
    Anterior: "上一个",
    "Próximo": "下一个",
    Proximo: "下一个",
    "Subir ao topo": "返回顶部",
    "Fechar opções": "关闭选项",
    "Selecione...": "请选择...",
    "Digite para filtrar...": "输入以筛选...",
    "Abrir calendário": "打开日历",
    "Alternar visualização do calendário": "切换日历视图",
    "Selecionar horário": "选择时间",
    "Cancelar seleção de horário": "取消时间选择",
    "Confirmar seleção de horário": "确认时间选择",
    Hora: "小时",
    "Filtrar por": "筛选依据",
    "Adicionar período": "添加期间",
    "Ajustar intervalo temporal": "调整时间范围",
    "Ajustar Intervalo Temporal": "调整时间范围",
    "Período rápido": "快捷期间",
    "Selecionar período": "选择期间",
    "Início selecionado": "已选择开始日期",
    "Escolha a data final no calendário.": "请在日历中选择结束日期。",
    "Use o calendário para escolher o início e o fim do período.": "使用日历选择期间的开始和结束。",
    "Esta Semana": "本周",
    "Semana Passada": "上周",
    "Este Mês": "本月",
    "Ano Passado": "去年",
    "Este Ano": "今年",
    "3 Meses": "3 个月",
    "6 Meses": "6 个月",
    Personalizado: "自定义",
    Janeiro: "一月",
    Fevereiro: "二月",
    Março: "三月",
    Abril: "四月",
    Maio: "五月",
    Junho: "六月",
    Julho: "七月",
    Agosto: "八月",
    Setembro: "九月",
    Outubro: "十月",
    Novembro: "十一月",
    Dezembro: "十二月",
    Jan: "1月",
    Fev: "2月",
    Mar: "3月",
    Abr: "4月",
    Mai: "5月",
    Jun: "6月",
    Jul: "7月",
    Ago: "8月",
    Set: "9月",
    Out: "10月",
    Nov: "11月",
    Dez: "12月",
    jan: "1月",
    fev: "2月",
    mar: "3月",
    abr: "4月",
    mai: "5月",
    jun: "6月",
    jul: "7月",
    ago: "8月",
    set: "9月",
    out: "10月",
    nov: "11月",
    dez: "12月",
    Dom: "周日",
    Seg: "周一",
    Ter: "周二",
    Qua: "周三",
    Qui: "周四",
    Sex: "周五",
    Sáb: "周六",
    Sab: "周六",
    "Importar dados": "导入数据",
    "Importe registros a partir de uma planilha .xlsx ou .csv.": "从 .xlsx 或 .csv 电子表格导入记录。",
    "Use um arquivo .xlsx ou .csv.": "请使用 .xlsx 或 .csv 文件。",
    "Não foi possível importar.": "无法导入。",
    "Importação concluída.": "导入完成。",
    "registro(s) importado(s).": "条记录已导入。",
    "Erro ao importar.": "导入时出错。",
    "Falha ao ler o arquivo.": "读取文件失败。",
    "Clique ou arraste o arquivo .xlsx ou .csv": "点击或拖入 .xlsx 或 .csv 文件",
    "Formatos aceitos: XLSX, CSV · Tamanho máximo: 25 MB": "支持格式：XLSX、CSV · 最大大小：25 MB",
    "Baixe o modelo para usar como ponto de partida.": "下载模板作为起点。",
    "Formatação do texto": "文本格式",
    Negrito: "加粗",
    Itálico: "斜体",
    Sublinhado: "下划线",
    Tachado: "删除线",
    "Cor do texto": "文字颜色",
    "Cor de realce": "高亮颜色",
    "Limpar formatação": "清除格式",
    "Inserir imagem": "插入图片",
    "Inserir link": "插入链接",
    "Inserir tabela": "插入表格",
    "Alinhar à esquerda": "左对齐",
    Centralizar: "居中",
    "Alinhar à direita": "右对齐",
    Justificar: "两端对齐",
    "Diminuir recuo": "减少缩进",
    "Aumentar recuo": "增加缩进",
    "Lista numerada": "编号列表",
    "Lista com marcadores": "项目符号列表",
    "Caractere especial": "特殊字符",
    Emoji: "表情",
    "Linha horizontal": "水平线",
    Fonte: "字体",
    "Tamanho da fonte": "字号",
    "Formato do bloco": "块格式",
    Desfazer: "撤销",
    Refazer: "重做",
    "Fonte do sistema": "系统字体",
    Parágrafo: "段落",
    "Título 1": "标题 1",
    "Título 2": "标题 2",
    "Título 3": "标题 3",
    Inserir: "插入",
    Colunas: "列",
    "Observação...": "备注...",
    Lista: "列表",
    Grade: "网格",
    "Modo de visualização": "视图模式",
    "Nenhuma notificação por aqui.": "这里没有通知。",
    "Buscar arquivo...": "搜索文件...",
    "Carregando anexos...": "正在加载附件...",
    "Anexar arquivo": "附加文件",
    Enviar: "发送",
    "Nenhuma noticia disponível.": "暂无可用新闻。",
    "Nenhuma notícia disponível.": "暂无可用新闻。",
    "Nenhuma nota encontrada.": "未找到便签。",
    "Validar CEP": "验证邮编",
    "Selecionar cor personalizada": "选择自定义颜色",
    "Cor personalizada": "自定义颜色",
    "Menu do usuário": "用户菜单",
    "Editar perfil": "编辑资料",
    "Fechar tour": "关闭引导",
    "Reiniciar tour guiado": "重新开始引导",
    "Alternar menu": "切换菜单",
    "Seu nome": "您的姓名",
    "Digite a senha atual": "输入当前密码",
    "Digite a nova senha": "输入新密码",
    "Alterar foto de perfil": "更改头像",
    "Selecione a empresa...": "选择公司...",
    "Observações do lançamento…": "分录备注...",
    "Financeiro — Receitas x Despesas": "财务 — 收入与支出",
    "Visao consolidada do período": "期间汇总视图",
    "Financeiro — Fluxo de caixa": "财务 — 现金流",
    "Entradas, saidas e saldo do período": "期间收入、支出和余额",
    "Estoque — Movimentações (30 dias)": "库存 — 流水（30 天）",
    "Entradas e saidas por dia": "每日收入和支出",
    "Entradas e saídas por dia": "每日收入和支出",
    "Estoque — Top produtos por saldo": "库存 — 按余额排名的产品",
    "Compras — Pedidos por status": "采购 — 按状态的订单",
    "Compras por dia": "每日采购",
    "Evolucao do valor comprado por data": "按日期的采购金额趋势",
    "Pedidos por status": "按状态的订单",
    "Compras por forma de pagamento": "按付款方式的采购",
    "Top fornecedores por volume comprado": "按采购量排名的供应商",
    "Distribuição dos pedidos": "订单分布",
    "Chamados por status": "按状态的工单",
    "Por prioridade": "按优先级",
    "Por categoria": "按类别",
    "Faturamento por dia": "每日收入",
    "Evolucao das vendas registradas": "已登记销售趋势",
    "Movimento do caixa PDV": "POS 收银流水",
    "Impacto diario das entradas e saidas": "收入和支出的每日影响",
    "Quantidade de vendas por dia": "每日销售数量",
    "Volume diario das vendas avulsas": "零散销售每日数量",
    "Vendas por status": "按状态的销售",
    "Receita por forma de pagamento": "按付款方式的收入",
    "Top clientes por faturamento": "按收入排名的客户",
    "Receitas × Despesas": "收入 × 支出",
    "Receitas por categoria": "按类别的收入",
    "Despesas por categoria": "按类别的支出",
    "Proporção do período": "期间占比",
    "Movimentações (últimos 30 dias)": "流水（最近 30 天）",
    "Top produtos por saldo": "按余额排名的产品",
    "Maior giro de estoque": "最高库存周转",
    "Saídas / estoque médio": "出库 / 平均库存",
    "Evolução mensal": "月度趋势",
    "Receita, despesas, CMV e lucro líquido ao longo do tempo.": "收入、支出、销售成本和净利润随时间变化。",
    "Composição da DRE": "损益表构成",
    "Participação dos principais grupos de receitas e custos.": "主要收入和成本组的占比。",
    Receitas: "收入",
    Despesas: "支出",
    Receita: "收入",
    "Lucro líquido": "净利润",
  },
};

